export default {
  photo_verification: {
    contact: {
      title: "Twoje konto czeka na weryfikację zdjęciem",
      text: "Nasz system bezpieczeństwa oznaczył Twój profil do sprawdzenia. Do czasu weryfikacji nie możesz korzystać z portalu. To nie jest ban: wystarczy, że potwierdzisz, że to naprawdę Ty.",
      submitted_title: "Sprawdzamy Twoje zdjęcie weryfikacyjne",
      submitted_text: "Zdjęcie do nas dotarło i nie musisz już nic robić ani do nas pisać. Gdy skończymy, konto odblokuje się automatycznie, a wynik dostaniesz mailem. Jeśli zdjęcie będzie nieczytelne, poprosimy o nowe z nowym kodem.",
      only_way: "Weryfikacja zdjęciem to jedyny sposób na odblokowanie konta. Nie odblokujemy go przez formularz kontaktowy ani mailowo, a wiadomości z prośbą o odblokowanie bez zdjęcia pozostaną bez odpowiedzi.",
      button: "Przejdź do weryfikacji",
      step_write: "Kliknij „Przejdź do weryfikacji” i napisz wyraźnie na kartce kod, który tam zobaczysz",
    },
    privacy: "To zdjęcie nie będzie publiczne. Zobaczy je tylko nasz zespół, a po weryfikacji je usuniemy.",
    camera_title: "Uśmiechnij się 🙂",
    camera_hint: "Trzymaj kartkę z kodem obok twarzy:",
    shoot: "Zrób zdjęcie",
    cancel: "Anuluj",
    camera_error: "Nie udało się uruchomić kamery. Zezwól przeglądarce na dostęp do kamery i spróbuj ponownie.",
    camera_unsupported: "Ta przeglądarka nie obsługuje aparatu. Otwórz JaTy w aktualnym Chrome, Safari lub Firefoksie na telefonie albo komputerze z kamerą.",
    camera_missing: "Nie znaleźliśmy kamery w tym urządzeniu. Zaloguj się na urządzeniu z aparatem lub kamerką, np. na telefonie albo laptopie z kamerką, i dokończ tam weryfikację.",
    camera_busy: "Kamera jest zajęta przez inny program. Zamknij aplikacje, które mogą jej używać (np. komunikatory wideo), i spróbuj ponownie.",
    camera_help: "Uzyskaj pomoc",
    title: "Potwierdź, że to Ty",
    intro: "Dbamy o to, by na JaTy były prawdziwe osoby. Prosimy Cię o szybką weryfikację zdjęciem. Do tego czasu nie możesz korzystać z portalu.",
    retry: "Na poprzednim zdjęciu nie udało nam się potwierdzić Twojej tożsamości. Mamy dla Ciebie nowy kod, spróbuj jeszcze raz.",
    your_code: "Twój kod",
    code_hint: "Kod zmienia się po każdym odświeżeniu strony",
    code_loading: "Generujemy Twój kod",
    step_write: "Napisz ten kod wyraźnie na kartce",
    step_selfie: "Zrób selfie, trzymając kartkę obok twarzy",
    step_send: "Wyślij zdjęcie. Sprawdzimy je najszybciej, jak się da",
    take_photo: "Zrób zdjęcie",
    preview_title: "Wszystko widać?",
    preview_text: "Upewnij się, że widać Twoją twarz i kod:",
    preview_alt: "Podgląd zdjęcia weryfikacyjnego",
    send: "Wyślij do weryfikacji",
    retake: "Zrób inne zdjęcie",
    submitted_title: "Dziękujemy! Zdjęcie jest u nas",
    submitted_text: "Sprawdzamy je teraz. Gdy skończymy, wszystkie funkcje wrócą automatycznie.",
    submitted_status: "Weryfikacja w toku…",
    check_status: "Sprawdź status",
    approved: "Gotowe! Twoje konto jest zweryfikowane 🎉",
  },
  profile_view: {
    "facts_title": "W skrócie",
    "open_gallery": "Zobacz zdjęcia: {name}",
    "view_gallery": "Zobacz wszystkie",
    "open_photo": "Otwórz zdjęcie {index}: {name}",
    "photo_alt": "{name} - zdjęcie {index}",
    "photo_position": "Zdjęcie {current} z {total}",
    "close_gallery": "Zamknij galerię",
    "previous_photo": "Poprzednie zdjęcie",
    "next_photo": "Następne zdjęcie",
    "back_to_profile": "Wróć do profilu",
    "photo_error": "Nie udało się wczytać zdjęcia. Spróbuj ponownie za chwilę.",
    "about_empty_title": "Nie każda historia zaczyna się od opisu.",
    "about_empty_description": "{name} nie ma jeszcze opisu. Czasem kilka słów w rozmowie mówi więcej niż cały profil.",
    "details_empty_title": "Tych szczegółów jeszcze nie ma w profilu. Więcej odkryjecie w rozmowie.",
    "photos_empty_description": "Na razie bez zdjęć - może pojawią się z czasem."
},
  consent: {
    "title": "Twoja prywatność w JaTy",
    "description": "Niezbędne cookies obsługują logowanie, bezpieczeństwo i Twoje wybory. Za Twoją zgodą Google Analytics mierzy korzystanie ze strony, a JaTy zapamiętuje źródło rejestracji. Możesz odmówić i dalej korzystać z serwisu.",
    "necessary": "Niezbędne – zawsze aktywne",
    "necessary_description": "Sesja, bezpieczeństwo, wybrany język i zapamiętanie Twoich ustawień. Działają niezależnie od zgody na analitykę.",
    "analytics": "Analityka",
    "analytics_description": "Google Analytics oraz zapamiętanie kampanii i pierwszej odwiedzonej strony przy rejestracji. Po odmowie konto nadal działa, ale nie zapisujemy tych informacji o jego pozyskaniu.",
    "simple_analytics": "Zbiorcze statystyki Simple Analytics działają bez cookies i respektują Do Not Track. Nie łączymy ich z Twoim kontem.",
    "accept": "Akceptuję wszystkie",
    "reject": "Tylko niezbędne",
    "settings": "Ustawienia cookies",
    "save": "Zapisz wybór",
    "close": "Zamknij ustawienia",
    "storage_unavailable": "Przeglądarka nie pozwoliła zapisać wyboru. Obowiązuje on na tej stronie; przy kolejnej wizycie zapytamy ponownie."
},
  login: 'Logowanie',
  language_picker: 'Wybór języka',
  login_do: 'Zaloguj się',
  logout: 'Wyloguj się',
  or: 'lub',
  terms: 'Regulamin',
  cookies_policy: 'Polityka cookies',
  privacy_policy: 'Polityka prywatności',
  legal_nav: {
    label: 'Dokumenty prawne',
    back_to_login: 'Wróć do logowania',
    back_to_app: 'Wróć do serwisu'
  },
  email: 'E-mail',
  password: 'Hasło',
  success: 'Udało się!',
  comeback: 'Wróć',
  to: 'do',
  login_to: 'logowania',
  something_wrong: 'Przepraszamy coś poszło nie tak',
  ask_for_another_email: 'Poproś o nowego maila',
  send: 'Wyślij',
  find_love_online: 'Znajdź miłość online',
  fast_login: 'Szybkie logowanie',
  hi: 'Cześć',
  woman: 'Kobieta',
  man: 'Mężczyzna',
  continue: 'Dalej',
  cancel: 'Anuluj',
  save_changes: 'Zapisz zmiany',
  premium_for_month: 'Jesteś premium przez najbliższy miesiąc!',
  see_partners_suggestions: 'Zobacz propozycje partnerów',
  kilometer: 'km',
  from: 'od',
  reset_do: 'Resetuj',
  parameters: 'Parametry',
  change_do: 'Zmień',
  city: 'Miejscowość',
  distance: 'Odległość',
  save_parameters: 'Zapisz parametry',
  propositions: 'Propozycje',
  hearts: 'Serduszka',
  your_pairs: 'Twoje pary',
  your_profile: 'Twój profil',
  check_profile: 'Zobacz profil',
  problem: 'Problem',
  are_you_sure: 'Czy jesteś pewien?',
  change_order: 'Zapisz kolejność',
  yes_delete: 'Tak, usuń',
  hide_menu: 'Schowaj menu',
  show_menu: 'Pokaż menu',
  month: 'miesiąc',
  three_months: 'miesiące',
  twelve_months: 'miesiący',
  go_back_home: 'Powrót na stronę główną',
  see_more: 'Zobacz więcej',
  and: 'i',
  close: 'Zamknij',
  get_now: 'Odbierz teraz',
  buy_now: 'Zakup teraz',
  you_are_pair_with: 'Jesteście parą z',
  you_are_offline: 'Wygląda na to, że jesteś offline. <a href="/">Odśwież stronę</a>',
  close_this_window: 'Zamknij to okno',
  not_now: 'Nie teraz',
  not_found: 'Nie znaleziono',
  something_went_wrong: 'Coś poszło nie tak :(',
  homepage: 'Strona główna',
  account: {
    confirmed: 'Twoje konto zostało potwierdzone! Możesz się zalogować!',
    confirmed_already: 'Twoje konto zostało już wcześniej potwierdzone',
    wrong_password: 'Nieprawidłowy login lub hasło',
    cant_login_now: 'Nie można się teraz zalogować',
    login: 'Zaloguj się',
    login_slogan: 'Dobrze, że jesteś. Zobacz, co nowego.',
    no_account: 'Nie masz konta?',
    your: 'Twoje konto',
    password: {
      change: 'Zmiana hasła',
      forgot: 'Zapomniałeś hasła?',
      remind: 'Przypomnienie hasła',
      remind_now: 'Przypomnij teraz',
      change_now: 'Zmień hasło',
      changed_successfully: 'Udana zmiana hasła! Możesz się zalogować',
      check_your_email: 'Sprawdź swojego maila',
      to_reset_password: 'aby odzyskać hasło',
      current: 'Obecne hasło',
      new: 'Nowe hasło',
      repeat_new: 'Powtórz nowe hasło',
      change_success: 'Hasło zostało zmienione!',
    },
    lang_choose: {
      is: 'Wybór języka',
    },
    notification_preferences: {
      is: 'Preferencje powiadomień',
      email_notification: 'Powiadomienia e-mail',
      about_hearts: 'Otrzymuj powiadomienia o dostawanych serduszkach',
      about_pairs: 'Otrzymuj powiadomienia o nowych parach',
      about_payments: 'Otrzymuj powiadomienia o statusie płatności',
      about_messages: 'Otrzymuj powiadomienia o nowych wiadomościach',
      push_status_text: 'Status powiadomień na tym urządzeniu i tej przeglądarce',
      push_not_yet_given: 'jeszcze nie przyznane',
      push_given: 'przyznane',
      push_not_given: 'nie przyznane'
    }
  },
  web_push: {
    on: 'Włącz powiadomienia',
    off: 'Powiadomienia wyłączone',
    we_cant_turn_on: 'Nie możemy włączyć powiadomień',
    manual_turn_on_help: 'Aby włączyć powiadomienia musisz przejść do ustawień przeglądarki i nadać uprawnienia powiadomień dla naszej strony samodzielnie.',
    turn_on_description: 'Włącz powiadomienia o nowych <br> <strong>serduszkach</strong>, <strong>parach</strong>, <strong>wiadomościach</strong>?',
    yes_turn_on: 'Tak, włącz'
  },
  chat: {
    delivery_failed: 'Wiadomość nie została wysłana',
    delivery_unconfirmed: 'Nie potwierdzono wysłania',
    retry: 'Ponów',
    search: 'wyszukaj...',
    no_new: 'Nie masz żadnych czatów',
    lets_talk: 'Porozmawiajmy!',
    choose_person: 'Wybierz osobę, z którą chciałbyś porozmawiać.',
    no_more_messages: 'Nie ma więcej wiadomości',
    load_more_messages: 'Załaduj więcej wiadomości',
    send: 'Wyślij',
    do_you_want_to_dislike: 'Chcesz odrzucić wiadomość?',
    do_you_want_to_dislike_text: 'Jeżeli odrzucisz wiadomość dalsza komunikacja z użytkownikiem będzie niemożliwa',
    yes_dislike: 'Tak, odrzuć',
    new_messages: 'nowe wiadomości',
    new_message: 'nowa wiadomość',
    read: 'Przeczytano'
  },
  register: {
    do: 'Zarejestruj się',
    on_jaty: 'Rejestracja na JaTy',
    description_text: 'Daj się poznać. Reszta zacznie się od rozmowy.',
    you_got_free_month: 'Otrzymałeś od nas <b>darmowy</b> miesiąc!',
    social_login_error: 'Nie można zalogować się przez Facebooka. Prawdopodobnie Twój profil nie udostępnia adresu email.',
    or_register: 'lub zarejestruj się',
    first_name: 'Imię / pseudonim',
    accept_policy: 'Akceptuję <a href="{privacy_url}" target="_blank" rel="nofollow">politykę prywatności</a> oraz <a href="{terms_url}" target="_blank" rel="nofollow">regulamin</a>.'
  },
  contact: {
    do: 'Kontakt',
    with_us: 'Kontakt z JaTy',
    with_us_do: 'Skontaktuj się z nami.',
    slogan: 'Masz pytanie? Chętnie pomożemy.',
    topic: 'Temat',
    describe: 'Opisz swój problem',
    thanks: 'Dziękujemy za przesłanie formularza. Odpowiemy jak najszybciej!',
    account_notice: {
      title: 'Sprawa dotyczy Twojego konta? Napisz z konta',
      text: 'Logowanie, profil, zdjęcia, blokada, płatności — zaloguj się i napisz przez formularz dostępny po zalogowaniu.',
      why: 'Stąd nie potwierdzimy, że konto jest Twoje, więc nie odpowiemy.',
      login: 'Zaloguj się i napisz z konta',
    },
    account_modal: {
      title: 'Czy Twoja sprawa dotyczy konta?',
      text: 'Jeśli tak, zamknij to okno, zaloguj się i napisz do nas przez formularz w strefie zalogowanej. Tylko wtedy zobaczymy, o które konto chodzi, i będziemy mogli pomóc.',
      login: 'Zaloguj się i napisz z konta',
      send: 'Sprawa nie dotyczy konta — wyślij',
    },
  },
  facebook: {
    login: 'Logowanie przez Facebook'
  },
  faq: {
    is: 'FAQ',
    how_heart_works: 'Jak działa "serduszko"?',
    how_heart_works_answer: 'Serduszko to prosty sposób, by dać komuś znać, że chcesz go lepiej poznać. Gdy je wyślesz, druga osoba otrzyma powiadomienie o Twoim zainteresowaniu. Jeśli ona również wyśle serduszko Tobie, automatycznie zostaniecie połączeni w parę i zobaczycie się w zakładce „Twoje pary”.',
    heart_flow_you: 'Ty',
    heart_flow_other_person: 'Druga osoba',
    heart_flow_mutual: 'Oboje wysyłacie sobie serduszka',
    heart_flow_pair: 'Możecie zacząć rozmowę',
    make_attractive: 'W jaki sposób zwiększyć swoją atrakcyjność na JaTy?',
    make_attractive_answer_first_part: 'Warto uzupełnić profil zdjęciami i informacjami o sobie. Dzięki temu osoby, które Cię zobaczą, łatwiej poczują, kim jesteś i czego szukasz, a propozycje będą lepiej dopasowane do Ciebie.',
    make_attractive_answer_second_part: 'Duże znaczenie mają też zdjęcia. Wybierz wyraźne fotografie, na których dobrze Cię widać i które przedstawiają właśnie Ciebie. Grafiki, awatary i przypadkowe obrazki zwykle nie pomagają w nawiązaniu kontaktu.',
    inappropriate_content: 'Ktoś zamieścił nieodpowiednie treści!',
    inappropriate_content_answer_first_part: 'Po naciśnięciu ikonki',
    inappropriate_content_answer_second_part: 'na profilu lub karcie użytkownika możesz wysłać zgłoszenie. Sprawdzimy je możliwie szybko i podejmiemy odpowiednie działania. Zależy nam, aby JaTy było miejscem, w którym można czuć się swobodnie i bezpiecznie.',
    user_blocking: 'Jak działa blokowanie użytkownika?',
    user_blocking_answer: 'Po zablokowaniu użytkownik nie będzie mógł do Ciebie napisać ani zobaczyć Twojego profilu. Ty również nie będziesz widzieć go w propozycjach i wynikach wyszukiwania. To dyskretne rozwiązanie, gdy nie chcesz mieć z kimś dalszego kontaktu.',
    no_answer: 'Nie znalazłeś odpowiedzi?',
    no_answer_answer: 'Napisz do nas przez formularz kontaktowy. Opisz krótko swoją sprawę, a postaramy się pomóc najszybciej, jak to możliwe.',
  },
  safety_tips: {
    title: 'Jak rozpoznać oszusta',
    intro: 'Większość osób w JaTy po prostu chce kogoś poznać. Zdarzają się jednak konta zakładane po to, żeby wyłudzić pieniądze lub dane. Moderacja wyłapuje wiele z nich, ale nie zawsze od razu – dlatego warto znać kilka sygnałów ostrzegawczych.',
    signs_title: 'Sygnały ostrzegawcze',
    signs: {
      money: 'Prośba o pieniądze w jakiejkolwiek formie: przelew, pożyczka, doładowanie, karta podarunkowa albo kryptowaluty. Powód bywa wzruszający – choroba, bilet na przyjazd, cło za paczkę, zablokowane konto.',
      codes: 'Prośba o kod BLIK, kod z SMS-a, dane logowania do banku albo zdjęcie dowodu osobistego.',
      off_site: 'Naleganie, żeby szybko przenieść rozmowę na inny komunikator, albo linki do „weryfikacji”, płatności lub innych serwisów.',
      too_fast: 'Bardzo szybkie wyznania uczuć i profil, który wygląda zbyt idealnie – przy jednoczesnym unikaniu rozmowy wideo.',
      investment: 'Rozmowy o inwestycjach, kryptowalutach albo „pewnym sposobie na zarobek”, w którym rozmówca chętnie pomoże.',
      no_meeting: 'Ciągłe wymówki, żeby się nie spotkać – praca za granicą, misja wojskowa, platforma wiertnicza.',
      pressure: 'Presja albo szantaż: „tylko dziś”, „jeśli mi ufasz…”, groźby publikacji Twoich zdjęć lub rozmów.',
    },
    protect_title: 'Jak się chronić',
    protect: {
      no_money: 'Nie wysyłaj pieniędzy ani kodów osobie, którą znasz tylko z internetu – nawet jeśli rozmawiacie od tygodni.',
      no_links: 'Nie otwieraj linków do płatności ani „weryfikacji konta” od rozmówcy. Weryfikacja zdjęciem w JaTy odbywa się tylko w serwisie, nigdy przez link od innej osoby.',
      report: 'Gdy coś Cię niepokoi, zgłoś profil ikoną z trzema kropkami na profilu i zablokuj tę osobę. Druga osoba nie dowie się, kto ją zgłosił.',
      meet: 'Na pierwsze spotkanie wybierz miejsce publiczne i powiedz komuś zaufanemu, dokąd idziesz.',
    },
    too_late_title: 'Pieniądze lub dane już wyszły?',
    too_late: 'Nie wstydź się – takie oszustwa są dopracowane i dotykają bardzo różnych ludzi. Od razu skontaktuj się ze swoim bankiem, zmień hasła, zachowaj zrzuty ekranu rozmowy i zgłoś sprawę na policję albo do CERT Polska (incydent.cert.pl). Przy szantażu nie płać – zapłata zwykle nie kończy żądań. Napisz też do nas, żebyśmy mogli zablokować konto.',
    blocked_title: 'Konto Twojej pary zostało zablokowane',
    blocked: 'Blokujemy konta, które złamały nasze zasady – na przykład przez spam, próby wyłudzenia albo fałszywy profil. Nie podajemy szczegółów, bo decyzja dotyczy innej osoby. Para i rozmowa z nią znikają z Twojej listy.',
    blocked_next: 'Jeśli ta osoba prosiła Cię o pieniądze, kody lub dane albo przeniosła rozmowę poza JaTy, zakończ także tamten kontakt i niczego nie wysyłaj. Jeśli coś już się stało, zobacz punkt wyżej.',
    deleted_title: 'Konto Twojej pary zostało usunięte',
    deleted: 'To decyzja tej osoby i nie oznacza, że zrobiła coś złego – ani że to Twoja wina. Razem z kontem znikają para i rozmowa. Informację o usunięciu widzisz w powiadomieniach przez 30 dni.',
    report: 'Masz pytanie albo chcesz coś zgłosić?',
  },
  welcome: {
    incentive: 'Uzupełnij jak najwięcej informacji w swoim profilu, aby pomóc nam znaleźć najlepsze propozycje osób dla Ciebie',
    sex: 'Twoja płeć',
    looking_for_women: 'Kobiet',
    looking_for_men: 'Mężczyzn',
    looking_for: 'Szukam',
    search_city: 'Powiedz nam, gdzie szukasz partnera',
    search_city_help: 'Zobaczą Cię osoby Tobą zainteresowane z pobliskich miejscowości.',
    lives_here: 'Mieszkam w kraju, w którym szukam partnera',
    seeking_elsewhere_warning: 'Możesz mieszkać w innym kraju niż ten, w którym szukasz partnera. Jeśli podajesz te informacje w opisie profilu, powinny być zgodne z wybranymi tutaj krajami.',
    residence_city: 'Powiedz nam, gdzie mieszkasz',
    your_year: 'Twój rocznik',
    preferred_partner_age: 'Poszukuję partnerów w wieku',
    about_title: 'Napisz coś o sobie',
    about_text: `
                <p class="mb-6">Niech inne osoby lepiej Cię poznają. Napisz coś  o sobie w kilku słowach lub zdaniach.</p>
                <p>Możesz napisać:</p>
                <ul class="mb-6 dotted">
                    <li>jaką jesteś osobą,</li>
                    <li>czym się zajmujesz i jakie masz hobby,</li>
                    <li>jakiej osoby szukasz i jakie są Twoje zamiary,</li>
                    <li>brak Ci słów? Wstaw emoji 😉</li>
                </ul>`,
    about_me: 'O mnie',
    smile: 'Uśmiech!',
    images_text: `Prześlij swoje najlepsze zdjęcia, aby zrobić wrażenie na osobach odwiedzających Twój profil.`,
    use_face_image: 'Wybierz zdjęcie, na którym widać Twoją twarz,',
    max_size: 'użyj zdjęć w formacie jpg lub png do 8MB,',
    use_your_images: 'nie używaj cudzych zdjęć,',
    use_appropriate_images: 'unikaj przesyłania zdjęć obraźliwych, nagich.',
    images_drop: `
                <p class="is-hidden-desktop-only is-hidden-touch  ">
                    Naciśnij tutaj lub przeciągnij zdjęcia z komputera.
                </p>
                <p class="is-visible-desktop is-hidden-widescreen ">Naciśnij tutaj aby dodać zdjęcia.</p>
                <p class="m-0">
                    Możesz zmieniać kolejność zdjęć.
                </p>`,
    max_images: 'Maksymalna liczba zdjęć to 8',
    image_required: 'Dodanie zdjęcia jest obowiązkowe.',
    image_from_fb: 'Pobraliśmy Twoje zdjęcia z Facebook\'a',
    main_after_text: 'Zdjęcie główne',
    skip_this_step: 'Pomiń ten krok',
    you_can_add_images_later: 'Zdjęcia możesz dodać później z poziomu edycji profilu',
    confirm_skipping: 'Tak, przejdź dalej',
  },
  emoji_picker: {
    most_used: 'Naczęściej używane',
    people: 'Ludzie',
    nature: 'Natura',
    objects: 'Obiekty',
    places: 'Miejsca',
    symbols: 'Symbole',
  },
  help: {
    is: 'Pomoc',
    and_contact: 'Pomoc i kontakt',
    center: 'Centrum pomocy',
    faq: 'FAQ',
    safety_tips: 'Jak rozpoznać oszusta',
    delete_account: 'Usuwanie konta',
  },
  users: {
    send_heart: 'Wyślij serduszko',
    skip_person: 'Pomiń osobę',
    no_description: 'Tutaj na razie jest cicho. Może za jakiś czas pojawi się kilka słów o sobie.',
    reaction_hint_title: 'Podoba Ci się {name}? Daj serduszko!',
    reaction_hint: 'Wzajemne serduszka otwierają czat.',
    discovery_guide: {
      female_title: 'Wybieraj po swojemu',
      female_story: 'Jeśli ktoś Cię zaciekawi, daj serce i zobacz, czy zainteresowanie będzie wzajemne.',
      male_title: 'Pierwszy krok jest prosty',
      male_story: 'Jeśli ktoś Cię zaciekawi, daj serce i zobacz, czy zainteresowanie będzie wzajemne.',
      instructions: 'Jak działają reakcje na kartach',
      heart_action: 'Okaż zainteresowanie.',
      heart_description: 'Wzajemne serca otwierają czat.',
      skip_action: 'Zignoruj.',
      skip_description: 'Ukryj propozycję na jakiś czas.',
    },
    discovery_end: {
      eyebrow: 'To jeszcze nie koniec historii',
      title_start: 'Wybierz',
      title_connector: 'albo',
      title_emphasis: 'przy każdej osobie',
      title_end: ', a wkrótce pojawi się tu więcej osób',
      heart_label: 'serce',
      skip_label: 'krzyżyk',
      story: 'Każda decyzja robi miejsce na nowe propozycje.\nKto wie - może jedno serce otworzy drogę do pierwszej rozmowy?',
      action: 'Dokończ wybieranie',
      technical: 'Wzajemne serduszko automatycznie otworzy czat.',
    },
    more_actions: 'Więcej działań dla profilu {name}',
    first_heart: {
      title_female_1: '{name} jeszcze nie wie, że chcesz ją poznać',
      status_female_1: 'Czasem dobra rozmowa zaczyna się od małego znaku.',
      title_female_2: 'Może {name} czeka właśnie na ciekawą rozmowę?',
      status_female_2: 'Daj znać, że ten profil przyciągnął Twoją uwagę.',
      title_female_3: 'Ciekawi Cię, jaka jest {name} po drugiej stronie ekranu?',
      status_female_3: 'Pierwszy krok nie musi być trudny.',
      title_male_1: '{name} jeszcze nie wie, że chcesz go poznać',
      status_male_1: 'Czasem dobra rozmowa zaczyna się od małego znaku.',
      title_male_2: 'Może {name} czeka właśnie na ciekawą rozmowę?',
      status_male_2: 'Daj znać, że ten profil przyciągnął Twoją uwagę.',
      title_male_3: 'Ciekawi Cię, jaki jest {name} po drugiej stronie ekranu?',
      status_male_3: 'Pierwszy krok nie musi być trudny.',
      action: 'Wyślij serduszko',
      technical: 'Jeśli {name} odwzajemni zainteresowanie, czat otworzy się automatycznie.',
    },
    pending_heart: {
      title_female_1: 'Wiemy, że podoba Ci się {name}',
      description_female_1: 'Żebyście mogli porozmawiać, {name} musi odwzajemnić Twój gest.',
      title_female_2: '{name} już wie, że chcesz ją poznać',
      description_female_2: 'Wysłaliśmy jej powiadomienie. Do rozmowy brakuje tylko jej odpowiedzi.',
      title_female_3: 'Pierwszy krok masz już za sobą',
      description_female_3: '{name} dostała sygnał od Ciebie. Gdy odpowie, czat będzie gotowy.',
      reminder_female: 'Bez obaw - co jakiś czas przypomnimy jej o Twoim profilu.',
      title_male_1: 'Wiemy, że podoba Ci się {name}',
      description_male_1: 'Żebyście mogli porozmawiać, {name} musi odwzajemnić Twój gest.',
      title_male_2: '{name} już wie, że chcesz go poznać',
      description_male_2: 'Wysłaliśmy mu powiadomienie. Do rozmowy brakuje tylko jego odpowiedzi.',
      title_male_3: 'Pierwszy krok masz już za sobą',
      description_male_3: '{name} dostał sygnał od Ciebie. Gdy odpowie, czat będzie gotowy.',
      reminder_male: 'Bez obaw - co jakiś czas przypomnimy mu o Twoim profilu.',
      action: 'Anuluj wysłane serduszko',
    },
    paired_heart: {
      title_female_1: 'Macie wzajemne serduszko!',
      status_female_1: 'Ty i {name} możecie już rozmawiać.',
      title_female_2: '{name} odwzajemniła Twój gest',
      status_female_2: 'To dobry moment, żeby napisać pierwszą wiadomość.',
      title_female_3: 'To może być początek dobrej rozmowy',
      status_female_3: '{name} też chce Cię poznać.',
      title_male_1: 'Macie wzajemne serduszko!',
      status_male_1: 'Ty i {name} możecie już rozmawiać.',
      title_male_2: '{name} odwzajemnił Twój gest',
      status_male_2: 'To dobry moment, żeby napisać pierwszą wiadomość.',
      title_male_3: 'To może być początek dobrej rozmowy',
      status_male_3: '{name} też chce Cię poznać.',
      action: 'Otwórz czat',
      technical: 'Czat jest już otwarty dla Was obojga.',
      cancel: 'Zakończ parę',
    },
    incoming_heart: {
      title_female_1: '{name} już zrobiła pierwszy krok',
      status_female_1: 'Dała Ci znać, że chce Cię lepiej poznać.',
      title_female_2: '{name} polubiła Twój profil',
      status_female_2: 'Teraz ruch należy do Ciebie.',
      title_female_3: '{name} zainteresowała się Twoim profilem',
      status_female_3: 'Właśnie zrobiła pierwszy krok.',
      title_male_1: '{name} już zrobił pierwszy krok',
      status_male_1: 'Dał Ci znać, że chce Cię lepiej poznać.',
      title_male_2: '{name} polubił Twój profil',
      status_male_2: 'Teraz ruch należy do Ciebie.',
      title_male_3: '{name} zainteresował się Twoim profilem',
      status_male_3: 'Właśnie zrobił pierwszy krok.',
      action_female: 'Też chcę ją poznać',
      action_male: 'Też chcę go poznać',
      technical: 'Po Twojej odpowiedzi czat otworzy się od razu.',
      processing_title: 'Łączymy Was...',
      processing_description: 'Otwieramy czat z {name}.',
      decline_title: 'Nie chcesz odwzajemnić serduszka?',
      decline_description: 'Ta osoba zniknie z listy otrzymanych serduszek.',
      decline_action: 'Tak, pomiń',
    },
    open_chat: 'Otwórz rozmowę',
    currently_looking_at_distance: 'Aktualnie szukasz w odległości',
    from_city: 'miejscowości',
    near_you: 'Blisko Ciebie',
    lives_in: 'Mieszka w',
    search_parameters: 'Parametry wyszukiwania',
    include_living_elsewhere: 'Pokazuj osoby, które mieszkają w innym kraju, ale szukają partnera tutaj',
    age_you_are_looking: 'Szukasz osób  w wieku',
    change_age: 'Zmień wiek',
    add_images: 'Dodaj zdjęcie',
    add_images_description: 'Dodaj swoje zdjęcie po to aby pomóc innym w znalezieniu Cię i odblokuj propozycje partnerów.',
    go_to_image_adding: 'Przejdź do dodawania zdjęć',
    add_photo: {
      description: 'Za każdą znajomością stoi ktoś prawdziwy. Pokaż siebie i odblokuj propozycje osób, które możesz poznać.',
      action: 'Dodaj moje zdjęcie',
      hint: 'Nie musi być idealne. Ważne, żeby było Twoje.',
      your_place: 'To miejsce dla Ciebie',
      hello: 'Wszystko zaczyna się od „cześć”',
    },
    discovery_empty: {
      initial: {
        title: 'Dobre znajomości',
        title_accent: 'mają swój moment.',
        description: 'Na razie nie mamy osób pasujących do Twoich preferencji.',
      },
      exhausted: {
        title: 'Na teraz to wszystko.',
        title_accent: 'Wpadnij znów!',
        description: 'Zajrzyj za jakiś czas. Kolejna wizyta może przynieść nową znajomość.',
      },
      waiting: {
        title: 'Daj serduszkom',
        title_accent: 'chwilę, żeby trafiły do Ciebie.',
        description: 'Na razie nikt nie wysłał Ci serduszka. Zajrzyj tu później - być może właśnie wtedy ktoś zrobi pierwszy krok.',
      },
      sent: {
        title: 'Dobra rozmowa może zacząć się',
        title_accent: 'od jednego serduszka.',
        description: 'Na razie nikomu nie wysłałeś serduszka. Poznaj nowe osoby - jedno z nich może być początkiem czegoś ważnego.',
      },
      return_message: 'Wpadnij ponownie - daj się zaskoczyć.',
      links_label: 'Zajrzyj w międzyczasie',
      discover_action: 'Poznaj nowe osoby',
      sent_hearts_action: 'Wysłane serduszka',
      received_hearts_action: 'Otrzymane serduszka',
      profile_action: 'Twój profil',
      photos_action: 'Twoje zdjęcia',
      hearts_action: 'Serduszka',
      pairs_action: 'Twoje pary',
    },
    want_to_see_more: 'Chesz zobaczyć więcej osób?',
    go_change_your_preferences: 'Dostosuj swoje preferencje, aby zobaczyć więcej propozycji osób.',
    change_preferences: 'Zmień parametry',
    card: {
      active_now_w: 'Aktywna teraz',
      active_now_m: 'Aktywny teraz',
      active_recently_w: 'Aktywna niedawno',
      active_recently_m: 'Aktywny niedawno',
      no_photo: 'Na razie bez zdjęcia',
      liked_you: 'Masz serduszko',
      your_move: 'Teraz Twój ruch!',
      like_back: 'Odwzajemnij serduszko i od razu zacznijcie czatować.',
      photos: 'Zdjęcia profilowe',
      photo: 'Zdjęcie {number}: {name}',
      show_photo: 'Pokaż zdjęcie {number}',
      previous_photo: 'Poprzednie zdjęcie',
      next_photo: 'Następne zdjęcie',
    },
    he_sent_you_a_heart: 'Wysłał Ci serduszko',
    she_sent_you_a_heart: 'Wysłała Ci serduszko',
    height: 'Wzrost',
    physique: 'Budowa ciała',
    children: 'Dzieci',
    eye_color: 'Kolor oczu',
    marital_status: 'Stan cywilny',
    work: 'Praca',
    education: 'Edukacja',
    confession: 'Wyznanie',
    attitude_to_marriage: 'Stosunek do małżeństwa',
    report: 'Zgłoś',
    block: 'Zablokuj',
    report_user: 'Zgłoś użytkownika',
    reason: 'Powód',
    ugly_profile: 'Obraźliwy profil - zdjęcia / opis',
    report_other: 'Inne',
    stealing_personal_data: 'Próba wymuszenia danych osobowych',
    stealing: 'Próba kradzieży / wymuszenia pieniędzy',
    hate_talk: 'Propagowanie nienawiści',
    fake: 'Podszywanie się (podejrzenie fake konta)',
    also_block_user: 'Dodatkowo zablokuj użytkownika',
    sure_to_black_and_unpair: 'Czy na pewno chcesz zablokować użytkownika i zerwać parę?',
    sure_to_black: 'Czy na pewno chcesz zablokować użytkownika?',
    block_user: 'Blokada użytkownika',
    yes_block: 'Tak, zablokuj',
    blocked: 'Użytkownik został zablokowany',
    thanks_for_report: 'Dziękujemy za zgłoszenie',
    write_more: 'napisz więcej...',
    looking_for: 'Szukam',
    looking_for_women: 'kobiet',
    looking_for_men: 'mężczyzn',
    aged: 'w&nbsp;wieku',
    click: 'Naciśnij',
    and_start_talking: 'i zacznij <br> rozmawiać na czacie!',
    visits: 'Odwiedziny',
    images: 'Zdjęcia',
    who_visited_you: 'Kto Cię odwiedził?',
    deleted: 'Wybrany użytkownik nie istnieje',
    one_time: 'raz',
    times: 'razy',
    no_new_visits: 'Nie masz nowych wyświetleń',
    users_not_found: 'Użytkownik nie został znaleziony',
    not_found_page: {
      title: 'Ten użytkownik nie istnieje',
      reasons_intro: 'Możliwe przyczyny:',
      reason_link: 'link jest błędny lub niekompletny',
      reason_deleted: 'użytkownik usunął swoje konto',
      reason_banned: 'konto zostało zablokowane',
      back: 'Wróć do propozycji'
    },
    pair: {
      are_you_sure_to_break: 'Chcesz zerwać parę',
      are_you_sure_to_break_confirm: 'Czy na pewno chcesz to zrobić?',
      yes_break: 'Tak, zerwij'
    },
    heart: {
      cancel_q: 'Chcesz anulować serduszko?',
      cancel_confirm: 'Serduszko które wysłałeś wcześniej zostanie anulowane.',
      yes_cancel: 'Tak, anuluj serduszko',
    }
  },
  current_user: {
    edit_profile: 'Edytuj profil',
    edit_images: 'Edytuj zdjęcia',
    basic_info: 'Informacje podstawowe',
    edit_success: 'Edycja profilu udana!',
    edit_cooldown: 'Imię, rocznik, miasto, miejsce zamieszkania i płeć możesz zmieniać tylko raz na jakiś czas.',
    more: {
      about_me: 'Więcej o mnie'
    },
    preferences: {
      is: 'Preferencje'
    },
    images: {
      is: 'Twoje zdjęcia',
      header: 'Zaprezentuj się z <span>najlepszej</span> strony!',
      from_computer: 'Naciśnij tutaj lub przeciągnij zdjęcia z komputera',
      from_mobile: 'Naciśnij tutaj aby dodać zdjęcia',
      can_change_order: 'Możesz zmieniać kolejność zdjęć.',
      uploaded_images: 'Przesłane zdjęcia',
      max_size_image: 'Zdjęcie {name} nie może być większe niż 8MB',
      order_changed: 'Edycja kolejności udana!',
      confirm_delete: 'Usuwanie zdjęć',
      confirm_delete_text: 'Czy na pewno chcesz to zrobić? Tej operacji nie można cofnąć?',
    },
    lang: {
      choose: 'Wybór języka'
    }
  },
  profile: {
    edit: 'Edycja profilu'
  },
  premium: {
    is: 'Premium',
    account: 'Konto premium',
    buy: 'Przedłużanie premium',
    see_with: 'Zobacz z',
    PREMIUM: 'PREMIUM',
    to: 'Twoje konto jest premium do',
    see_benefits: 'Zobacz korzyści premium',
    hide: 'Schowaj',
    benefits: 'Możliwości',
    free: 'Free',
    no_ads: 'Brak reklam',
    be_higher: 'Wyświetlaj się wyżej <span class="is-hidden-mobile"> innym użytkownikom</span>',
    ukraine: `🇺🇦 100% wpłat wykonanych przez naszych użytkowników w okresie 05.03.2022 do odwołania przekażemy na zbiórkę <a
      href="https://pomagam.pl/solidarnizukraina" target="_blank" rel="nofollow"> 🇺🇦 "Solidarni z Ukrainą"</a>
      organizowaną przez fundację <a href="https://pomagam.pl/" target="_blank" rel="nofollow">pomagam.pl</a>.
      Dokumentacja tej incjatywy dostępna będzie na naszym profilu na <a
      href="https://www.facebook.com/jatyportalrandkowy" target="_blank" rel="nofollow">facebook'u</a>. Zachęcamy do
      polubienia 🇺🇦`,
    see: 'Zobacz',
    more_with: 'Więcej korzyści z',
    expires: 'Jesteś premium do'
  },
  like: {
    hearts: 'Serduszka',
    sent: 'Wysłane',
    received: 'Otrzymane',
    you_didnt_sent_to_anyone: 'Jeszcze nikomu nie wysłałeś serduszka',
    go_to_propositions_to_like: 'Przejdź do propozycji i nawiąż kontakty z osobami, które pasują do Twoich preferencji.',
    sent_hero_title: 'Serduszka',
    sent_hero_description: 'Osoby, które polubiłeś, zobaczą Twoje serduszko. Gdy odwzajemnią zainteresowanie, otworzy się czat.',
    sent_hero_story: 'Czekasz na wzajemne serduszko',
    received_hero_title: 'Serduszka',
    received_hero_story: 'Odwzajemnij i zacznij czat',
    linking_description: 'Ktoś wysłał Ci serduszko? Odwzajemnij je, aby stworzyć parę i od razu rozpocząć rozmowę.',
    nobody_sent_you: 'Jeszcze nikt nie wysłał Ci serduszka'
  },
  pair: {
    yours: 'Twoje pary',
    page_description: 'Tutaj widzisz osoby, które Ci się podobają z wzajemnością',
    no: 'Nie masz jeszcze żadnej pary'
  },
  delete_request: {
    title: 'Usuwanie konta',
    stay_eyebrow: 'Zanim się pożegnamy',
    stay_title: 'W JaTy każda rozmowa może zacząć coś ważnego',
    stay_text: 'Rozwijamy JaTy razem z osobami, które tu są. Może warto dać sobie i nam jeszcze jedną szansę - nowe profile, jedno serduszko albo zwykłe „cześć” czasem prowadzą dalej, niż się spodziewasz.',
    stay_action: 'Wróć do poznawania osób',
    description: `
    <p class="mb-2">Usunięcie konta trwale usuwa:</p>
    <ul class="mb-2 dotted">
      <li>twoich danych,</li>
      <li>twoich zdjęć,</li>
      <li>twojej historii wiadomości,</li>
      <li>twojego abonamentu.</li>
    </ul>
    <p class="mb-2">Nie wysyłamy wiadomości e-mail dotyczących tego procesu, więc:</p>
    <ul class="dotted mb-2">
      <li><b>Nie</b> otrzymasz powiadomienia o usunięciu konta.</li>
      <li><b>Nie</b> otrzymasz powiadomienia o wysłaniu żądania.</li>
      <li><b>Nie</b> otrzymasz powiadomienia o dodatkowych pytaniach.</li>
    </ul>
    <p class="mb-2">Osoby, z którymi masz parę lub rozmowę, przez 30 dni zobaczą w powiadomieniach, że Twoje konto zostało usunięte, wraz z Twoim imieniem lub pseudonimem.</p>
    <p class="has-text-danger delete-text mb-2">Tego procesu nie można cofnąć.</p>
    <p class="mb-2">Możesz zarejestrować się ponownie, ale Twoje obecne konto nie będzie już dostępne.</p>
    <p class="mb-0">Jeśli mimo wszystko chcesz usunąć konto, napisz, co możemy poprawić, i wyślij prośbę o usunięcie.</p>`,
    reason: 'Co najbardziej nie podobało Ci na naszym portalu? (obowiązkowe)',
    ask: 'Poproś o usunięcie konta',
    cant_cancel: `
      <div class="content">
        <p class="has-text-centered has-text-primary is-size-3 mb-2">♡</p>
        <p class="has-text-weight-semibold has-text-centered">Pamiętaj, że tego procesu nie można cofnąć.</p>
        <div class="notification is-info has-text-white">
          JaTy jest darmowe, więc nic nie tracisz, zostając z nami jeszcze chwilę. Daj sobie szansę na poznanie kogoś wartościowego, rozmowę albo miłość, która może przyjść wtedy, kiedy najmniej się jej spodziewasz.
        </div>
      </div>
      `,
    yes_delete: 'Tak, poproś o usunięcie konta',
    no: 'Zostaję i daję sobie szansę',
    last_step: 'Ostatni krok',
    press_yes_to_delete: 'Naciśnij "Tak" jeżeli chcesz trwale wykasować swoje dane',
    permanently: 'Tak, bezpowrotnie usuń konto'
  },
  email_confirmation: {
    resend: 'Wyślij jeszcze raz.',
    didnt_received: 'E-mail nie dotarł?',
    go_to_email: 'Przejdź na swój e-mail, aby go potwierdzić',
    mail_sent: 'Mail został wysłany',
    already_send_in_10_minutes: 'W ciagu ostatnich 10 minut poprosiłeś o ponowne wysłanie maila',
    on_mail: 'na skrzynkę',
    you_she_received: 'dostałaś',
    you_he_received: 'dostałeś',
    email_sent_from_us: 'od nas e‑mail z instrukcjami jak potwierdzić Twoje konto.',
    do_now: 'Potwierdź swój adres email!',
    great_last_step: 'Świetnie! Ostatni krok!',
    delivered_hint: 'Sprawdziliśmy — ten e‑mail od nas wyszedł. Jeśli go nie widzisz, zajrzyj do spamu i ofert.',
    contact: {
      title: 'Sprawdziliśmy — e‑mail z potwierdzeniem od nas wyszedł',
      text: 'Mamy potwierdzenie, że wiadomość z linkiem potwierdzającym została wysłana na adres:',
      where_to_look: 'Zanim do nas napiszesz, sprawdź foldery Spam, Oferty i Powiadomienia oraz wyszukaj „JaTy”. Nie potwierdzimy konta za Ciebie — trzeba kliknąć link z tego e‑maila.',
    },
  },
  payment: {
    you_save: 'Oszczędzasz',
    mon: 'mies',
    choose_one: 'Wybierz jedeną z opcji',
    go_to_p24: 'Przejdź do Przelewy24',
    thanks_title: 'Dziękujemy za opłacenia zamówienia!',
    thanks_text: 'Poinforujemy Cię kiedy tylko dostaniemy informację o Twojej płatności.',
    choosen: 'Wybrano',
    digital: {
      active: 'Nie musisz już nic robić. Twoja subskrypcja jest aktywna.',
      deactived_globally: 'Płatności z poziomu aplikacji wyłączone.',
      manage: 'Zarządzaj subskrybcją',
      active_now: 'Aktywuj teraz',
      seven_days_free: '7 dni za darmo',
      with_subscription: 'subskrybcję',
    },
  },
  alert: {
    is: 'Powiadomienia',
    description: 'Widzisz listę powiadomień, które pozwalają Ci kontrolować co nowego dzieje się na Twoim koncie.',
    read_all: 'Oznacz wszystkie jako przeczytane',
    no_new: 'Nie masz nowych powiadomień',
    nothing: 'Nic ciekawego się nie dzieje',
    see_all: 'Zobacz wszystkie powiadomienia',
    one_more_step: 'Jeszcze jeden krok',
    new: 'Nowe',
    add_more_info_about_you: 'Uzupełnij informacje o sobie',
    you_are_premium: 'Jesteś premium',
    your_account_is_premium: 'Twoje konto zostało przedłużone',
    you_are_pair: 'Jesteście parą',
    description_warning: 'Twój opis został usunięty',
    photos_warning: 'Twoje zdjęcia zostały usunięte',
    you_received_warning_for_description: 'Otrzymałeś ostrzeżenie za opis, ponieważ nie spełniał zasad regulaminu',
    you_received_warning_for_photos: 'Na razie otrzymałeś tylko ostrzeżenie. Nie akceptujemy zdjęć zawierających nagość lub przemoc, zdjęć w bieliźnie, zdjęć męskich nagich torsów, zdjęć przedstawiających osoby inne niż Ty ani zdjęć zawierających dane kontaktowe.',
    pair_banned: 'Konto zablokowane za złamanie zasad. Nie wysyłaj tej osobie pieniędzy ani kodów – zobacz, na co uważać',
    pair_deleted: 'Konto usunięte. Wasza para i rozmowa zniknęły razem z nim',
  },
  profile_photo_rules: {
    label: 'Zasady dodawania zdjęć',
    face: 'Na zdjęciu głównym Twoja twarz musi być wyraźnie widoczna.',
    forbidden: 'Tych zdjęć nie dodawaj',
    sexual: 'Nagość, nieobyczajne pozy i treści seksualne.',
    clothing: 'Zdjęcia w bieliźnie. Zdjęcia w stroju kąpielowym poza naturalnym kontekstem, takim jak plaża lub basen.',
    children: 'Zdjęcia dzieci bez widocznego obok rodzica lub opiekuna.',
    identity: 'Zdjęcia grupowe, cudze fotografie i wszystkie obrazy, na których Cię nie ma.',
    offensive: 'Treści obraźliwe, przedstawiające przemoc lub nawołujące do nienawiści.',
  },
  profile_description_rules: {
    title: 'Zasady publicznego opisu',
    text: 'Nie podawaj danych kontaktowych ani linków do komunikatorów i mediów społecznościowych. Nie dodawaj reklam ani bezpośrednich propozycji seksualnych. Naruszenie zasad może skutkować usunięciem opisu i ostrzeżeniem.',
    link: 'Przeczytaj pełne zasady opisu w regulaminie'
  },
  premium_box: {
    twa: `
     <span class="has-text-primary">Premium</span> na 7 dni za FREE! Potem&nbsp;<span
              class="has-text-danger">50&#37;</span>&nbsp;zniżki.`,
    left: 'Pozostało',
    countdown_text: `<span class="has-text-primary">Premium</span> za <span class="countdown-price">29.99&nbsp;zł</span>
              <span class="countdown-promo-price has-text-danger">69.99&nbsp;zł</span>
              na&nbsp;12&nbsp;miesięcy! <br>`,
    text: `JaTy staje się portalem <span class="has-text-primary">darmowym</span> dla wszystkich! Od piątego marca
           2022 premium to tylko dwie korzyści:&nbsp;"brak reklam" i "nieznaczne wyświetlanie się wyżej w wynikach
           wyszukiwania". Reszta funkcjonalności staje się darmowa! <br><br> 🇺🇦 100% wpłat wykonanych przez naszych
           użytkowników w okresie 05.03.2022 do odwołania przekażemy na zbiórkę
           <a href="https://pomagam.pl/solidarnizukraina" target="_blank" rel="nofollow">🇺🇦 "Solidarni z Ukrainą"</a>
           organizowaną przez fundację <a href="https://pomagam.pl/" target="_blank" rel="nofollow">pomagam.pl</a>.
           Dokumentacja tej incjatywy dostępna będzie na naszym profilu na <a
           href="https://www.facebook.com/jatyportalrandkowy" target="_blank" rel="nofollow">facebook'u</a>.
           Zachęcamy do  polubienia 🇺🇦`
  },
  city_chooser: {
    loading: 'Ładowanie',
    no_results: 'Brak wyników',
    no_results_residence: 'Miasta z kraju, w którym szukasz partnera, nie są tutaj dostępne. Jeśli mieszkasz w tym samym kraju, zaznacz „Mieszkam w kraju, w którym szukam partnera”.'
  },
  home: {
    chat_image_alt: 'Rozmowa na czacie w portalu randkowym JaTy',
    app_image_alt: 'Podgląd portalu randkowego JaTy na telefonie i komputerze',
    moderation: `
          <p class="mb-3">
            Za JaTy stoi administracja, która reaguje na nadużycia i blokuje konta łamiące zasady serwisu.
            Wspiera ją sztuczna inteligencja (AI): pomaga sprawdzać profile, moderować treści i wykrywać podejrzane zachowania.
            Dzięki temu możemy sprawniej ograniczać fałszywe konta, spam i próby oszustwa.
          </p>
          <p class="mb-3">
            AI pomaga nam dbać o przestrzeń do poznawania ludzi. To Ty wybierasz, z kim rozmawiasz, komu wysyłasz serduszko
            i czy chcesz spotkać się poza internetem. Zależy nam, żeby więcej uwagi można było poświęcić znajomościom,
            a mniej niechcianym zaczepkom.
          </p>
          <p>
            Żaden system moderacji nie wykryje każdego nadużycia i może się pomylić.
            Jeśli coś budzi Twój niepokój, skorzystaj ze zgłoszenia na profilu użytkownika.
            W sprawie problemów z kontem lub działaniem serwisu możesz też <a href="{contact_url}">napisać do administracji JaTy</a>.
            Twoje zgłoszenia pomagają nam dbać o społeczność.
          </p>`,
    h1: 'Darmowy portal randkowy',
    go_for_jaty: 'Przejdź na JaTy',
    login: 'Logowanie',
    register: 'Rejestracja',
    thousands_of_users: 'Tysiące użytkowników',
    every_day_new_users: 'Codziennie nowi użytkownicy!',
    totally_free: 'Całkowicie darmowy',
    all_features_free: 'Wszystkie funkcje dostępne za darmo!',
    only_real_accounts: 'Aktywna moderacja',
    accounts_constantly_verified: 'Administracja wspierana przez AI',
    safe_guarantee_title: 'Dbamy o Twoje bezpieczeństwo',
    ssl: 'Certyfikat SSL',
    spam_filter: 'Filtr antyspamowy',
    fake_control: 'Wykrywanie fałszywych kont',
    hero_intro: 'Poznaj kogoś, z kim chce się rozmawiać. Miłość, przyjaźń, a może pierwsza wspólna kawa?',
    hero_note: 'Bez opłat. W Twoim tempie. Dla osób 18+.',
    about_label: 'O nas',
    about_heading: 'Poznaj historię JaTy',
    about_intro: 'Zaczęło się od pomysłu na portal dla znajomych. Dziś rozwijamy niezależne, darmowe miejsce do poznawania ludzi. Dowiedz się, kto za nim stoi i co jest dla nas ważne.',
    about_link: 'Więcej o JaTy',
    how_it_works: 'Jak to działa',
    discover: 'Zobacz, jak to działa',
    chat_graphic_section_h1: 'Portal randkowy - znajdź prawdziwą miłość',
    chat_intro: 'Kilka prostych kroków do nowej znajomości. Ty decydujesz, co będzie dalej.',
    steps: [
      {
        title: 'Pokaż, kim jesteś',
        text: 'Dodaj zdjęcie i kilka słów o sobie. Wybierz, kogo chcesz poznać.'
      },
      {
        title: 'Daj serduszko',
        text: 'Przeglądaj profile. Gdy polubicie się nawzajem, zostaniecie parą.'
      },
      {
        title: 'Zacznij rozmowę',
        text: 'Napisz pierwszą wiadomość. Na spotkanie przyjdzie czas, kiedy zechcecie.'
      }
    ],
    free_heading: 'JaTy jest portalem <strong class="has-text-primary">darmowym</strong>',
    free_intro: 'Czat, serduszka i parowanie są darmowe. Bez subskrypcji i płatnego odblokowywania kontaktu.',
    free_label: 'za wszystkie funkcje',
    free_features: [
      'Rozmowy',
      'Serduszka',
      'Parowanie',
      'Wyszukiwanie'
    ],
    safety_intro: 'Administracja wspierana przez AI sprawdza treści i reaguje na nadużycia. Ty wybierasz, z kim chcesz rozmawiać.',
    moderation_heading: 'Jak AI i administracja pomagają dbać o randki online?',
    online_to_live_heading: 'Randkowanie online zmienia się w randki na żywo',
    online_to_live: `
          <p class="mb-3">
            JaTy to portal randkowy online, dzięki któremu możesz budować długoterminowe relacje, ale również poznawać przyjaciół po to, aby pójść z kimś na spacer, drinka lub do kina.
            Internet pomaga wykonać pierwszy krok, szczególnie wtedy, gdy na co dzień brakuje czasu, odwagi albo okazji do poznawania nowych osób.
          </p>
          <p class="mb-3">
            Dobra rozmowa potrafi szybko pokazać, czy macie podobne poczucie humoru, wartości, plany i styl życia.
            Dlatego randki online są często początkiem czegoś bardzo realnego: spotkania na żywo, wspólnego weekendu, stałego związku albo przyjaźni, która zostaje na dłużej.
          </p>
          <p>
            Serwis działa w przeglądarce, więc możesz korzystać z niego na telefonie, tablecie i komputerze bez instalowania aplikacji.
            Twoje konto jest dostępne tam, gdzie masz internet, a rozmowy możesz prowadzić wygodnie w domu, w podróży albo w wolnej chwili w ciągu dnia.
          </p>`,
    app_label: 'Zawsze pod ręką',
    faq_title: 'Darmowe randki online – najczęściej zadawane pytania',
    faq_intro: 'Kilka odpowiedzi przed pierwszym „cześć”.',
    faq_items: [
      {
        question: 'Czy portal randkowy JaTy naprawdę jest darmowy?',
        answer: `<p>
              Tak. Rozmowy, serduszka, parowanie, przeglądanie profili i wyszukiwanie są dostępne za darmo.
              JaTy nie wymaga płatnej subskrypcji, pakietu premium ani jednorazowych opłat za odblokowanie kontaktu.
            </p>
<p class="mt-1">Funkcje potrzebne do randkowania online są dostępne bez opłat.</p>`
      },
      {
        question: 'Dlaczego JaTy jest darmowy?',
        answer: `<p>
              Chcemy dać użytkownikom realną szansę na znalezienie miłości, przyjaźni albo wartościowej znajomości bez płacenia za samą możliwość rozmowy.
              Dlatego koncentrujemy się na prostych narzędziach do poznawania ludzi, bezpieczeństwie, ograniczaniu wulgarnych treści i bieżącej kontroli fałszywych kont.
            </p>`
      },
      {
        question: 'Kim będą ludzie, których poznam?',
        answer: `<p>
              JaTy zrzesza osoby z całej Polski i ze świata, które szukają miłości, przyjaźni, rozmowy albo stałego związku.
              Przywiązujemy dużą wagę do tego, aby ograniczać fałszywe konta i nieuczciwe zachowania.
              Żaden portal randkowy nie może obiecać, że każdy profil będzie idealny, ale stale pracujemy nad tym, aby społeczność JaTy była możliwie autentyczna i bezpieczna.
            </p>`
      },
      {
        question: 'Czy rejestracja jest trudna?',
        answer: `<p>
              Nie. <a href="{register_url}">Rejestracja</a> w JaTy jest prosta i zajmuje tylko chwilę.
              Po założeniu konta możesz uzupełnić profil, dodać zdjęcie, określić swoje preferencje i zacząć poznawać osoby, które również są zainteresowane randkami online.
            </p>`
      },
      {
        question: 'Czy mogę korzystać z JaTy bez aplikacji?',
        answer: `<p>
              Tak. Obecnie JaTy działa jako portal randkowy w przeglądarce. Możesz korzystać z niego na telefonie, tablecie i komputerze bez instalowania aplikacji mobilnej.
              To wygodne rozwiązanie dla osób, które chcą mieć dostęp do profilu i wiadomości z różnych urządzeń.
            </p>`
      },
      {
        question: 'Jak działają portale randkowe?',
        answer: `<p>
              Różne portale randkowe działają na różne sposoby, ale cel jest podobny: pomóc ludziom poznać kogoś, z kim można zbudować relację, przyjaźń albo prawdziwą miłość.
              W JaTy możesz przeglądać profile, wysyłać serduszka, korzystać z parowania i pisać wiadomości, gdy ktoś Cię zainteresuje.
            </p>`
      },
      {
        question: 'Dla kogo jest JaTy?',
        answer: `<p>
              JaTy jest dla dorosłych singli, osób samotnych, nieśmiałych, zapracowanych i wszystkich, którzy chcą poznawać ludzi online w spokojny sposób.
              Możesz szukać poważnego związku, przyjaźni, rozmowy albo osoby, z którą pójdziesz na spacer, kawę, drinka lub do kina.
            </p>`
      },
      {
        question: 'Czy JaTy jest dostępny tylko dla osób dorosłych?',
        answer: `<p>
              Tak. Z portalu mogą korzystać wyłącznie osoby dorosłe. JaTy nie jest miejscem do oszukiwania innych, szukania zarobku ani publikowania wulgarnych treści.
              Naszym celem jest pomaganie ludziom w poznawaniu prawdziwych osób i budowaniu normalnych relacji.
            </p>`
      },
      {
        question: 'W jaki sposób dbamy o Twoje dane?',
        answer: `<p>
              Nikt niezarejestrowany na portalu nie zobaczy Ciebie ani Twoich danych profilowych.
              Nie udostępniamy danych użytkowników innym podmiotom w celach, które byłyby sprzeczne z działaniem serwisu.
              Stosujemy standardy bezpieczeństwa po to, aby użytkownicy mogli korzystać z JaTy możliwie anonimowo poza portalem i spokojnie decydować, komu chcą ujawnić więcej informacji o sobie.
            </p>`
      }
    ],
    closing_intro: 'Załóż darmowe konto. Daj się poznać.',
    footer_note: 'Miejsce na nowe znajomości.',
    chat_graphic_section: `
          <p class="mb-3">
            Randki online JaTy to szansa na poznanie kogoś, z kim rozmowa naprawdę ma znaczenie.
            Darmowy portal randkowy pomaga zacząć spokojnie: bez presji, bez ukrytych kosztów i bez konieczności instalowania aplikacji.
            Wystarczy konto, uzupełniony profil i kilka wiadomości, żeby sprawdzić, czy między dwiema osobami pojawia się sympatia.
          </p>
          <p class="mb-3">
            W JaTy możesz poznawać singli z całej Polski, szukać osób z najbliższej okolicy albo otworzyć się na relacje z kimś mieszkającym dalej.
            Dla jednych randki internetowe są sposobem na znalezienie miłości, dla innych początkiem przyjaźni, rozmowy po pracy, wspólnego spaceru albo spotkania przy kawie.
            Najważniejsze jest to, że samodzielnie decydujesz, z kim chcesz pisać i kiedy chcesz przenieść znajomość poza internet.
          </p>
          <p class="mb-3">
            JaTy jest dla osób, które chcą poznać kogoś wartościowego: kobiet i mężczyzn szukających stałego związku, nowych znajomości, bliskości albo po prostu normalnej rozmowy.
            Dzięki funkcjom takim jak czat, serduszka, parowanie, przeglądanie profili i wyszukiwanie otrzymujesz wszystko, czego potrzebujesz, aby rozpocząć znajomość online.
          </p>
          <p>
            JaTy stawia na prostotę. Nie musisz znać skomplikowanych zasad ani spędzać wielu godzin na konfiguracji konta.
            Dodaj zdjęcie, napisz kilka zdań o sobie, określ, kogo chcesz poznać i zacznij przeglądać profile osób, które również szukają relacji.
            Darmowe randki online mogą być naturalne, wygodne i dostępne dla każdego dorosłego użytkownika.
          </p>`,
    free_heading_text: `
          <p class="mb-3">
            JaTy działa jako darmowy portal randkowy: rozmowy, serduszka, parowanie, przeglądanie profili i wyszukiwanie są dostępne bez opłat.
            Chcemy, żeby najważniejsze funkcje potrzebne do poznawania ludzi były dostępne dla każdego, kto szuka miłości, przyjaźni albo wartościowej znajomości.
          </p>
          <p class="mb-3">
            Darmowe randki online nie powinny polegać na tym, że użytkownik zakłada konto, a później dowiaduje się, że za każdą realną rozmowę trzeba dopłacić.
            W JaTy możesz zacząć pisać, reagować na profile, sprawdzać dopasowania i poznawać osoby bez subskrypcji, pakietów premium i płatnych odblokowań.
          </p>
          <p>
            Podstawowa idea pozostaje prosta: portal randkowy ma pomagać ludziom poznawać się online, a nie blokować kontakt za płatną ścianą.
          </p>`,
    we_will_help_you_for_free_heading: 'Poznaj kogoś bliskiego z JaTy – za darmo',
    we_will_help_you_for_free: `
          <p class="mb-3">
            Czy chciałbyś już dziś poznać kogoś wartościowego? Czy czujesz się samotny? Czy jesteś singielką lub singlem, który chce zacząć randki online bez presji i ukrytych kosztów?
            Jeżeli tak, darmowy portal randkowy JaTy jest miejscem dla Ciebie.
          </p>
          <p class="mb-3">
            Zarejestruj się, uzupełnij profil i napisz kilka zdań o tym, kim jesteś oraz kogo chcesz poznać.
            Im bardziej naturalny profil, tym łatwiej rozpocząć rozmowę z osobą, która szuka podobnej relacji: miłości, stałego związku, przyjaźni albo po prostu ciekawej znajomości.
          </p>
          <p class="mb-3">
            Nie obiecujemy magii ani gotowej recepty na związek. Dajemy za to narzędzia, które ułatwiają pierwszy kontakt: profile, wyszukiwanie, serduszka, parowanie i wiadomości.
            Czasem jedna prosta rozmowa wystarczy, żeby dzień stał się lepszy, a znajomość zaczęła rozwijać się w dobrą stronę.
          </p>
          <p>
            JaTy powstało dla ludzi, którzy nie chcą udawać kogoś innego. Możesz szukać spokojnie, we własnym tempie i bez presji natychmiastowego spotkania.
            To Ty decydujesz, komu odpiszesz, kogo polubisz i kiedy będziesz gotowy na randkę poza internetem.
          </p>`,
    app_heading: 'Darmowe randki online w przeglądarce',
    app: `
          <p class="mb-3">
            Portal randkowy JaTy działa wygodnie w przeglądarce telefonu i komputera.
            Możesz logować się tym samym kontem, przeglądać profile, wysyłać serduszka, dobierać pary i pisać wiadomości bez instalowania dodatkowej aplikacji.
          </p>
          <p class="mb-3">
            Randki przez przeglądarkę są proste: nie zajmują miejsca w telefonie, nie wymagają pobierania aktualizacji i pozwalają korzystać z serwisu na różnych urządzeniach.
            Wystarczy wejść na JaTy, zalogować się i wrócić do rozmów wtedy, gdy masz na to czas.
          </p>
          <p>
            Pracujemy nad tym, aby portal był czytelny, szybki i wygodny zarówno na smartfonie, jak i na większym ekranie.
            Dzięki temu możesz poznawać nowych ludzi w sposób, który pasuje do Twojego dnia: rano przy kawie, po pracy albo wieczorem, gdy masz chwilę tylko dla siebie.
          </p>`,
    read_more: 'Czytaj więcej',
    read_less: 'Zwiń opis'
  },
  meta: {
    home: 'Darmowy portal randkowy JaTy. Poznawaj singli, rozmawiaj na czacie i szukaj miłości bez opłat. Nad społecznością czuwa administracja wspierana przez AI.',
    login: 'Zaloguj się do JaTy. Wróć do swoich rozmów, sprawdź serduszka i poznawaj nowe osoby w darmowym portalu randkowym.',
    contact: 'Skontaktuj się z administracją JaTy. Napisz w sprawie konta, zgłoś problem z portalem lub poproś o pomoc w korzystaniu z serwisu.',
    logout: 'Wyloguj się - JaTy to darmowy portal randkowy online dla singli, osób samotnych i wszystkich, którzy chcą poznawać wartościowe osoby w internecie.',
    register: 'Załóż darmowe konto w JaTy. Dodaj zdjęcie, uzupełnij profil i poznawaj singli. Czat, serduszka i dopasowania bez subskrypcji i opłat.',
    redirect: 'Znajdź miłość online - JaTy to darmowy portal randkowy dla singli, którzy szukają rozmowy, przyjaźni, stałego związku i prawdziwych relacji.',
    fast_login: 'Szybkie logowanie - Wróć do JaTy i kontynuuj darmowe randki online, rozmowy, parowanie oraz poznawanie nowych osób w bezpiecznym portalu randkowym.',
    login_layout: 'JaTy to darmowy portal randkowy online, dzięki któremu możesz poznać wartościowe osoby, zacząć rozmowę i szukać miłości bez obowiązkowych opłat.',
    regulamin: 'Poznaj zasady korzystania z JaTy: warunki rejestracji, prawa i obowiązki użytkowników oraz zasady prowadzenia konta w serwisie.',
    polityka_prywatnosci: 'Sprawdź, jak JaTy przetwarza dane osobowe użytkowników, jakie prawa Ci przysługują i jak skontaktować się w sprawie swoich danych.',
    cookies: 'Dowiedz się, do czego JaTy używa plików cookies oraz jak zarządzać nimi w ustawieniach swojej przeglądarki.'
  },
  title: {
    login_layout: 'JaTy - darmowe randki online',
    help: 'Centrum pomocy - JaTy Randki online',
    safety_tips: 'Jak rozpoznać oszusta - JaTy Randki online',
    home: 'JaTy - darmowy portal randkowy i randki online',
    welcome: {
      index: 'Witaj - JaTy Randki online',
      about: 'Witaj - JaTy Randki online',
      images: 'Zdjęcia - JaTy Randki online'
    },
    users: {
      index: 'Propozycje - JaTy Randki online',
      liked: 'Serduszka - JaTy Randki online',
      liking: 'Serduszka - JaTy Randki online',
      _slug: ' - JaTy Randki online'
    },
    'current-user': {
      'verify-email': 'Potwierdź swój e-mail',
      payments: {
        digital: 'Premium - JaTy Randki online',
        index: 'Premium - JaTy Randki online',
        thanks: 'Dziękujemy - JaTy Randki online'
      },
      edit: {
        'delete-request': 'Usunięcie konta - JaTy Randki online',
        images: 'Zdjęcia - JaTy Randki online',
        index: 'Informacje podstawowe - JaTy Randki online',
        lang: 'Wybór języka - JaTy Randki online',
        'notification-preferences': 'Preferencje powiadomień - JaTy Randki online',
        password: 'Zmiana hasła - JaTy Randki online',
        preferences: 'Preferencje - JaTy Randki online',
        profile: 'Więcej o mnie - JaTy Randki online'
      }
    }
  },
  terms_of_use: `<article class="legal-doc">
    <header class="legal-doc__header">
      <h2 class="legal-doc__title">Ogólne Warunki Świadczenia Usługi Jaty</h2>
      <p class="legal-doc__subtitle">zwane dalej „Warunkami ogólnymi”</p>
    </header>

    <div class="legal-doc__intro">
      <p>Ogólne Warunki Świadczenia Usługi Jaty określają zasady korzystania z serwisu Jaty (zwanego dalej „Serwisem Jaty”). Operatorem serwisu i stroną umowy z Klientem jest WHIPO sp. z o.o. z siedzibą przy ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Polska, NIP: 5342666118, zwana dalej „Jaty”. Kontakt: <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>.</p>
      <p>Z chwilą zarejestrowania w Serwisie Jaty Klient oświadcza i zapewnia, że przeczytał i zaakceptował Warunki ogólne. Warunki ogólne stanowią tym samym integralną część umowy.</p>
      <p>Warunki ogólne obowiązują wszystkich klientów, również tych, którzy korzystają z Serwisu Jaty poza terytorium Polski.</p>
      <p>Korzystać z Serwisu Jaty mogą osoby, które ukończyły 18 lat.</p>
    </div>

    <nav class="legal-doc__toc" aria-label="Spis treści">
      <p class="legal-doc__toc-title">Spis treści</p>
      <ol>
        <li><a href="#pkt-1">1. Przedmiot umowy</a></li>
        <li><a href="#pkt-2">2. Korzystanie z Serwisu Jaty oraz zawarcie umowy</a></li>
        <li><a href="#pkt-3">3. Serwis Jaty oraz zakres świadczeń</a></li>
        <li><a href="#pkt-4">4. Kontakt i powiadomienia</a></li>
        <li><a href="#pkt-5">5. Odpowiedzialność cywilna Serwisu Jaty</a></li>
        <li><a href="#pkt-6">6. Obowiązki Klienta</a></li>
        <li class="legal-doc__toc-highlight"><a href="#moderacja">6a. Zasady profili, wiadomości, ostrzeżeń i banów – moderacja AI i odwołania</a></li>
        <li><a href="#pkt-7">7. Ochrona danych, przetwarzanie danych i cookies</a></li>
        <li><a href="#pkt-8">8. Wypowiedzenie umowy i wstrzymanie usługi</a></li>
        <li><a href="#pkt-9">9. Reklamacje</a></li>
        <li><a href="#pkt-10">10. Prawa autorskie</a></li>
        <li><a href="#pkt-11">11. Prawo do odstąpienia od umowy</a></li>
        <li><a href="#pkt-12">12. Zmiana Warunków ogólnych</a></li>
        <li><a href="#pkt-13">13. Pozostałe</a></li>
      </ol>
    </nav>

    <section id="pkt-1" class="legal-doc__section">
      <h3>1. Przedmiot umowy</h3>
      <ol class="legal-doc__clauses">
        <li>
          <p>Przedmiotem umowy zawartej pomiędzy Klientem a Serwisem Jaty są świadczenia nieodpłatne. Rejestracja i korzystanie z funkcji serwisu, w tym przeglądanie profili, wyszukiwanie, wysyłanie serduszek, parowanie oraz wiadomości, są bezpłatne. Serwis Jaty oferuje Klientowi między innymi następujące świadczenia (patrz również punkt 3. „Serwis Jaty oraz zakres świadczeń”):</p>
          <ul>
            <li>Wprowadzenie Klienta do bazy danych Serwisu Jaty oraz zarządzanie danymi;</li>
            <li>Umożliwienie kontaktu z innymi Klientami Serwisu Jaty.</li>
          </ul>
        </li>
        <li><p>Przedmiotem umowy pomiędzy Klientem a Serwisem Jaty nie jest ani kojarzenie małżeństw, ani pośrednictwo matrymonialne, ani aktywność zorientowana na bezpośrednie ustanowienie związku partnerskiego lub małżeństwa.</p></li>
        <li><p>Serwis Jaty służy prywatnemu poznawaniu ludzi. Działalność reklamowa, spam i wykorzystywanie serwisu do oszustw są zabronione. Szczegółowe zasady określa punkt 6a.</p></li>
        <li><p>Do korzystania z Serwisu Jaty niezbędne jest posiadanie urządzeń pozwalających na korzystanie z Internetu, skrzynki pocztowej e-mail oraz przeglądarki zasobów internetowych umożliwiającej wyświetlanie stron WWW.</p></li>
      </ol>
    </section>

    <section id="pkt-2" class="legal-doc__section">
      <h3>2. Korzystanie z Serwisu Jaty oraz zawarcie umowy</h3>
      <ol class="legal-doc__clauses">
        <li><p>Korzystanie z Serwisu Jaty wymaga rejestracji. Podczas rejestracji Klient podaje imię, pod którym widoczny będzie dla innych klientów Serwisu Jaty, oraz ustala hasło. Podany adres e-mail służy wyłącznie kontaktowaniu się Serwisu Jaty z Klientem i nie jest przekazywany innym Klientom Serwisu Jaty.</p></li>
        <li><p>Rejestrując się Klient akceptuje niniejsze Warunki ogólne oraz oświadcza, że jest pełnoletni, tzn. że ukończył 18 lat.</p></li>
        <li><p>Umowa pomiędzy Klientem a Serwisem Jaty zostaje zawarta z chwilą zarejestrowania się Klienta. Umowy tej dotyczą niniejsze Ogólne Warunki. Rejestracja jest bezpłatna.</p></li>
        <li><p>Serwis Jaty nie oferuje obecnie płatnych kont, płatnych pakietów ani subskrypcji. Dostęp do funkcji serwisu nie wymaga zaakceptowania obowiązku zapłaty.</p></li>
        <li><p>Klient oświadcza, że dane podane podczas rejestracji są prawdziwe.</p></li>
        <li><p>Jaty ma prawo zablokować dostęp do serwisu, jeżeli klient korzysta z serwisu i/lub strony internetowej naruszając przepisy prawne, naruszając jedno lub więcej praw osób trzecich lub łamiąc obowiązki klienta – szczegóły patrz dalej: <a href="#pkt-6">6. Obowiązki Klienta</a>. W przypadku ciężkiego naruszenia przez Klienta postanowień Warunków ogólnych lub umowy, Serwis Jaty zastrzega sobie prawo do dochodzenia roszczeń na zasadach przewidzianych przez obowiązujące przepisy prawa.</p></li>
      </ol>
    </section>

    <section id="pkt-3" class="legal-doc__section">
      <h3>3. Serwis Jaty oraz zakres świadczeń</h3>
      <ol class="legal-doc__clauses">
        <li><p>Świadczenie usług przez Serwis Jaty rozpoczyna się z chwilą rejestracji. Klient uzupełnia swój profil, który jest widoczny dla innych użytkowników Serwisu Jaty.</p></li>
        <li><p>Serwis Jaty umożliwia Klientom przeglądanie i wyszukiwanie profili, wysyłanie serduszek i parowanie. Wiadomości można wymieniać z osobami, z którymi utworzono parę (po wzajemnym wysłaniu serduszek), za pośrednictwem wewnętrznego systemu komunikacyjnego Serwisu Jaty. Serwis Jaty może proponować Klientowi profile, które mogą do niego pasować.</p></li>
        <li><p>Możliwość nawiązywania kontaktów oraz przekazywania wiadomości jest bezpłatna.</p></li>
        <li><p>Serwis Jaty nie pobiera obecnie opłat za dostęp do funkcji serwisu. Jeżeli w przyszłości zakres usług ulegnie zmianie, Klient zostanie poinformowany zgodnie z obowiązującymi przepisami prawa i niniejszym regulaminem.</p></li>
        <li>
          <p>Serwis Jaty nie gwarantuje, że podane przez Klientów dane są prawdziwe.</p>
          <p>Serwis Jaty nie gwarantuje, że w trakcie obowiązywania umowy dojdzie do wzajemnie skutecznego nawiązania kontaktu.</p>
        </li>
        <li><p>Zasadniczo, usługa świadczona przez Jaty dostępna jest 24/7. Dostępność szacuje się na 95% w ujęciu rocznym. Powyższa wartość nie obejmuje przerw związanych z konserwacją lub aktualizacją oprogramowania lub spowodowanych czynnikami, które nie są zależne od Jaty, jak niedostępność usług internetowych z winy osób trzecich lub z powodu siły wyższej. Jaty zaleca korzystanie z aktualnej wersji przeglądarki. W przypadku stosowania nieaktualnej lub niestandardowej technologii, Jaty nie może zagwarantować prawidłowego działania wszystkich usług i funkcji.</p></li>
      </ol>
    </section>

    <section id="pkt-4" class="legal-doc__section">
      <h3>4. Wzajemne powiadomienia dokonywane przez Klienta i Serwis Jaty</h3>
      <ol class="legal-doc__clauses">
        <li><p>Jaty przekazuje Klientowi wiadomości w serwisie po zalogowaniu lub na adres e-mail przypisany do konta.</p></li>
        <li><p>Klient może kontaktować się z Jaty e-mailem na adres <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a> lub przez formularz kontaktowy. W celu weryfikacji i ochrony przed nadużyciami Klient powinien pisać z adresu e-mail przypisanego do konta albo podać ten adres i swoją nazwę użytkownika.</p></li>
      </ol>
    </section>

    <section id="pkt-5" class="legal-doc__section">
      <h3>5. Odpowiedzialność cywilna Serwisu Jaty</h3>
      <ol class="legal-doc__clauses">
        <li><p>Serwis Jaty nie odpowiada w żaden sposób w granicach zgodnych z obowiązującymi przepisami prawa za materiały i dane przekazywane i publikowane na łamach Serwisu Jaty przez Klientów oraz za ich prawdziwość, rzetelność i autentyczność. Jeżeli dowiemy się o tym, że klient narusza przepisy prawne; narusza jedno lub więcej praw osób trzecich lub też narusza obowiązujące obecnie zobowiązania klienta określone w punkcie 6, wówczas zastosowanie znajduje punkt 2.6.</p></li>
        <li><p>Bezpośrednie podjęcie kontaktu pomiędzy Klientami Serwisu Jaty następuje wyłącznie za obopólną zgodą (patrz punkt 3 „Serwis Jaty oraz zakres świadczeń”). Serwis Jaty nie ponosi tym samym odpowiedzialności, jeśli w okresie obowiązywania umowy nie zostanie podjęty żaden kontakt. Serwis Jaty dokłada natomiast wszelkich starań w zakresie pośrednictwa w kontaktach pomiędzy Klientami Serwisu Jaty poprzez zapewnienie odpowiednich warunków technicznych. Serwis Jaty nie odpowiada za zdarzenia, które mogą mieć lub miały miejsce w świecie rzeczywistym pomiędzy Klientami, którzy poznali się za pośrednictwem Serwisu Jaty.</p></li>
        <li><p>Serwis Jaty nie odpowiada za nadużywanie przez innych danych i informacji, gdyż mimo wyraźnego zakazu (patrz punkt 6 „Obowiązki Klienta”) Klienci mogą korzystać z Serwisu Jaty z naruszeniem prawa. Serwis Jaty nie odpowiada tym samym również w przypadkach, gdy informacje, które Klient sam udostępnił osobie trzeciej, wykorzystywane są przez osobę trzecią w sposób bezprawny.</p></li>
        <li><p>Jaty nie gwarantuje, że serwis będzie działał bez zarzutu przez cały czas, tzn. że będzie nieustannie dostępny bez żadnych zakłóceń. W szczególności Jaty nie odpowiada za usterki sprzętu technicznego ani za jakość dostępu do usług z powodu działania siły wyższej lub zdarzeń będących poza kontrolą Jaty (np. awarii sieci komunikacyjnych).</p></li>
        <li><p>Jaty nie odpowiada za bezprawne pozyskanie danych osobowych klienta przez osoby trzecie, np. w formie dostępu do bazy danych przez hakerów.</p></li>
        <li><p>Za straty inne niż wynikające z w/w przyczyn Jaty będzie odpowiadać tylko w przypadkach zamierzonego lub rażącego zaniedbania ze strony swego kierownictwa, pracowników lub wykonawców, a odpowiedzialność taka jest proporcjonalna do innych powodów, które przyczyniły się do powstania straty.</p></li>
        <li><p>Jaty odpowiada tylko za nieznaczne zaniedbanie w przypadku uszczerbku na życiu, ciele lub zdrowiu lub w przypadku, gdy naruszył istotne zobowiązania umowne. Odpowiedzialność w tym drugim przypadku jest ograniczona do przewidywalnych, bezpośrednich strat typowych dla tego rodzaju stosunku umownego.</p></li>
        <li><p>Odpowiedzialność kontraktowa jest poza tym wykluczona.</p></li>
      </ol>
    </section>

    <section id="pkt-6" class="legal-doc__section">
      <h3>6. Obowiązki Klienta</h3>
      <ol class="legal-doc__clauses">
        <li>
          <p>Klient ponosi wyłączną odpowiedzialność za wszelkie podane przez siebie dane. Zapewnia on, że podane przez niego dane są prawdziwe. Klient zobowiązuje się nie przekazywać danych osób trzecich jako własnych. Podawanie fałszywych danych narusza postanowienia umowy oraz Warunków Ogólnych i może wiązać się z podjęciem przez Serwis Jaty stosownych kroków prawnych.</p>
          <p>Klient zobowiązuje się do utrzymywania danych podanych w Serwisie Jaty, w szczególności danych kontaktowych, w stanie zaktualizowanym.</p>
          <p>Serwis Jaty uprawniony jest do sprawdzania treści profilu, w tym zamieszczanych zdjęć, pod względem ich zgodności z prawem, Warunkami ogólnymi oraz umową. Serwis Jaty uprawniony jest do odrzucania, zmiany, a nawet usuwania treści danych.</p>
        </li>
        <li><p>W publicznym opisie profilu nie wolno zamieszczać danych do kontaktu poza Jaty. Szczegóły i zasady prywatnej wymiany kontaktów określa punkt 6a.</p></li>
        <li><p>Klient zobowiązany jest do poufnego traktowania danych (w szczególności nazwisk, adresów zamieszkania, adresów e-mail, adresów stron internetowych, numerów telefonów) dotyczących poczty elektronicznej, wiadomości i powiadomień otrzymywanych od innych Klientów Serwisu Jaty oraz do nieudostępniania tych danych osobom trzecim bez zgody osoby, której one dotyczą. Przekazywanie danych osób niebędących Klientami Serwisu Jaty jest zabronione.</p></li>
        <li><p>Klient nie może wykorzystywać Jaty do reklamy, spamu komercyjnego ani werbowania do innych serwisów. Zasady dotyczące prywatnych wiadomości określa <a href="#moderacja-wiadomosci">punkt 6a.3</a>.</p></li>
        <li>
          <p>Klient zobowiązuje się, że nie będzie korzystać z Serwisu Jaty w celu:</p>
          <ul>
            <li>rozsyłania materiałów bezprawnych, szkalujących lub naruszających zasady treści określone w punkcie 6a;</li>
            <li>grożenia, nękania, zniesławiania itp.;</li>
            <li>wyłudzania pieniędzy, danych lub dostępu do kont przez podstęp, przymus albo szantaż;</li>
            <li>naruszania praw osób trzecich.</li>
          </ul>
          <p>Klient zobowiązuje się ponadto do:</p>
          <ul>
            <li>niewprowadzania do Serwisu Jaty danych zawierających wirusy (zainfekowanego oprogramowania);</li>
            <li>niewprowadzania do Serwisu Jaty danych zawierających oprogramowanie lub inne materiały chronione prawem autorskim lub prawem własności przemysłowej, chyba że Klient jest posiadaczem danego prawa lub posiada konieczną zgodę posiadacza prawa do korzystania z oprogramowania lub materiałów;</li>
            <li>niekorzystania z Serwisu Jaty w sposób mogący negatywnie wpływać na dostępność oferty Serwisu Jaty dla innych Klientów;</li>
            <li>nieingerowania w system komputerowy innych Klientów, w tym w szczególności do niepodejmowania bezprawnych działań związanych z pocztą elektroniczną innych Klientów.</li>
          </ul>
        </li>
        <li><p>Reakcję na naruszenie dobieramy zgodnie z punktem 6a: może to być usunięcie opisu lub zdjęć i ostrzeżenie, ban albo skierowanie sprawy do ręcznej weryfikacji. Zasady te nie wyłączają roszczeń przysługujących na podstawie obowiązującego prawa.</p></li>
        <li><p>W przypadku wykorzystania danych z Serwisu Jaty do celów komercyjnych Jaty może dochodzić roszczeń na zasadach przewidzianych przez obowiązujące przepisy prawa.</p></li>
        <li><p>Klient zobowiązuje się zwolnić Serwis Jaty z wszelkich skutków powództw, roszczeń o odszkodowanie, strat i należności, które powstaną w związku z jego zarejestrowaniem się w Serwisie Jaty i korzystaniem z niego. Klient zwalnia Serwis Jaty z wszelkiej odpowiedzialności cywilnej oraz z wszelkich zobowiązań i szkód, które mogą wyniknąć na skutek roszczeń powstałych z powodu pomówienia lub znieważenia, oraz naruszenia praw innych Klientów.</p></li>
        <li>
          <p>Klient winien odbierać napływające do niego wiadomości i odpowiadać na nie regularnie i w razie potrzeby archiwizować je na własnym komputerze lub innym nośniku danych.</p>
          <p>Serwis Jaty może archiwizować lub usuwać starsze treści, w tym wiadomości, a także usuwać nieaktywne konta.</p>
        </li>
      </ol>
    </section>

    <section id="moderacja" class="legal-doc__section legal-doc__section--highlight">
    <h3>6a. Zasady profili, wiadomości i moderacji</h3>
    <p>Jaty jest serwisem dla osób pełnoletnich. Poniżej opisujemy, jakie treści są niedozwolone i jak reagujemy na naruszenia. Publiczny profil i prywatne rozmowy podlegają różnym zasadom.</p>
    <h4 id="moderacja-opisy">6a.1. Imię i opis profilu</h4>
    <p>Imię i opis powinny przedstawiać Ciebie zgodnie z prawdą. W publicznym profilu niedozwolone są w szczególności:</p>
    <ul>
      <li>dane kontaktowe poza Jaty (np. telefon, e-mail, komunikatory, media społecznościowe), także zapisane w ukryty sposób;</li>
      <li>treści o charakterze seksualnym, wulgarne lub obsceniczne;</li>
      <li>reklama, spam, werbowanie do innych serwisów oraz oferty płatnych usług lub treści erotycznych;</li>
      <li>groźby, nękanie, oszustwa i inne treści niezgodne z prawem.</li>
    </ul>
    <h4 id="moderacja-zdjecia">6a.2. Zdjęcia profilu</h4>
    <p>Zdjęcia profilu są publiczne i muszą być odpowiednie dla takiego miejsca. Niedozwolone są w szczególności nagość, treści o charakterze seksualnym lub obscenicznym, nieodpowiedni strój, przemoc oraz jakiekolwiek treści seksualizujące małoletnich. Zasada obejmuje także rysunki i obrazy wygenerowane komputerowo. Zdjęcia powinny przedstawiać Ciebie – niedozwolone są zdjęcia innych osób (np. osób publicznych) oraz dane kontaktowe umieszczone na zdjęciu.</p>
    <h4 id="moderacja-wiadomosci">6a.3. Prywatne wiadomości</h4>
    <p>W prywatnych rozmowach dorosłych dozwolona jest swobodna komunikacja, w tym wymiana kontaktów, flirt i rozmowy o charakterze seksualnym – o ile jest dobrowolna i mieści się w granicach przepisów prawa. Ograniczenia dotyczące publicznego profilu nie obowiązują w prywatnej rozmowie.</p>
    <p>Niedozwolone są w szczególności spam, reklama, oszustwa i wyłudzenia (np. pieniędzy, danych logowania lub kodów BLIK), szantaż, groźby oraz nękanie – w tym dalsze wysyłanie treści seksualnych osobie, która wyraźnie odmówiła.</p>
    <h4 id="moderacja-autentycznosc">6a.4. Autentyczność kont</h4>
    <p>Zabronione jest podszywanie się pod inne osoby, prowadzenie kont automatycznych (botów) oraz zakładanie kolejnych kont w celu obejścia blokady, wysyłania spamu lub wprowadzania innych w błąd.</p>
    <p>Możemy poprosić o potwierdzenie, że konto należy do osoby ze zdjęć, np. gdy lokalizacja połączenia nie pasuje do miasta podanego w profilu. Do czasu weryfikacji możliwość wysyłania wiadomości może być ograniczona, a brak weryfikacji lub jej negatywny wynik może skutkować blokadą konta.</p>
    <h4 id="moderacja-ai">6a.5. Jak wykorzystujemy AI</h4>
    <p>Do wykrywania naruszeń korzystamy z narzędzi sztucznej inteligencji, które sprawdzają opisy, zdjęcia, wiadomości i aktywność kont. Decyzje mogą być podejmowane automatycznie albo przez moderatora.</p>
    <p>AI może się pomylić – dlatego od każdej decyzji możesz się odwołać, a odwołanie rozpatruje człowiek (punkt 6a.7).</p>
    <h4 id="moderacja-kontekst">6a.6. Reakcje na naruszenia</h4>
    <p>W zależności od wagi naruszenia możemy usunąć treść (opis lub zdjęcia), wysłać ostrzeżenie albo zablokować konto (ban). Poważne naruszenie lub ponowne naruszenie po ostrzeżeniu może skutkować banem. Oceniamy treść w jej kontekście, a nie pojedyncze słowa. Ban blokuje dostęp do konta. Osoby, z którymi zablokowane konto miało parę lub rozmowę, otrzymują w serwisie powiadomienie o blokadzie wraz z imieniem lub pseudonimem i miniaturą zdjęcia z profilu, bez podawania jej przyczyny. Po cofnięciu blokady powiadomienie jest usuwane.</p>
    <h4 id="moderacja-odwolanie">6a.7. Zgłoszenia i odwołania</h4>
    <p>O ostrzeżeniu lub banie informujemy e-mailem. Możesz zgłosić naruszenie albo odwołać się od decyzji, pisząc na <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>. Odwołanie jest bezpłatne i nie wymaga zalogowania.</p>
    <p>Podaj nazwę użytkownika lub e-mail konta i napisz, dlaczego nie zgadzasz się z decyzją. Nie przesyłaj hasła. Odwołanie rozpatruje człowiek, który może zmienić decyzję. O wyniku informujemy e-mailem.</p>
    <p>Informacje o danych wykorzystywanych przy moderacji znajdziesz w <a href="/polityka-prywatnosci#moderacja-dane">polityce prywatności</a>.</p>
    </section>

    <section id="pkt-7" class="legal-doc__section">
      <h3>7. Informacje dotyczące ochrony danych, przetwarzania danych oraz cookies</h3>
      <p>Informacje o przetwarzaniu danych osobowych znajdują się w <a href="/polityka-prywatnosci">polityce prywatności</a>.</p>
    </section>

    <section id="pkt-8" class="legal-doc__section">
      <h3>8. Wypowiedzenie umowy oraz wstrzymanie świadczenia usługi</h3>
      <h4>8.1. Wypowiedzenie umowy</h4>
      <p>Umowa o korzystanie z Serwisu Jaty ma charakter nieodpłatny i powstaje z chwilą rejestracji Klienta w Serwisie Jaty.</p>
      <p>Klient jest w każdej chwili uprawniony do wypowiedzenia umowy bez podania przyczyny. Wypowiedzenie następuje przez usunięcie konta w ustawieniach konta (opcja „Usuń konto”). Osoby, z którymi Klient miał parę lub rozmowę, przez 30 dni widzą w powiadomieniach informację o usunięciu konta wraz z imieniem lub pseudonimem z profilu. Przy usunięciu konta do celów statystycznych zachowujemy wyłącznie ogólne informacje – płeć, wiek, miasto i podany powód rezygnacji – w formie, która nie pozwala powiązać ich z konkretną osobą.</p>
      <p>Serwis Jaty uprawniony jest do wypowiedzenia nieodpłatnej umowy z terminem wypowiedzenia 14 dni. Niezależnie od powyższego Serwis Jaty jest w każdej chwili uprawniony do wypowiedzenia umowy w przypadkach wskazanych w niniejszych Warunkach ogólnych oraz umowie.</p>
      <h4>8.2. Czas trwania umowy</h4>
      <p>Umowa o korzystanie z Serwisu Jaty trwa do czasu jej wypowiedzenia przez Klienta albo Serwis Jaty zgodnie z niniejszym regulaminem. Serwis Jaty nie stosuje obecnie płatnych abonamentów, automatycznych odnowień płatnych usług ani próbnych subskrypcji.</p>
      <h4>8.3. Zaprzestanie usług</h4>
      <p>Serwis Jaty ma prawo zaprzestać częściowo lub całkowicie świadczenia oferowanych usług. Jaty poinformuje klienta o planowanym ustaniu usługi i jego zakresie z wyprzedzeniem co najmniej 14 dni przed częściowym lub całkowitym ustaniem usługi.</p>
    </section>

    <section id="pkt-9" class="legal-doc__section">
      <h3>9. Reklamacje</h3>
      <ol class="legal-doc__clauses">
        <li>
          <p>Wszelkie reklamacje Klient może zgłaszać za pośrednictwem poczty elektronicznej lub pisemnie na podane poniżej adresy:</p>
          <p class="legal-doc__address">WHIPO sp. z o.o. – Jaty, ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Polska, NIP: 5342666118<br>E-mail: <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a></p>
        </li>
        <li>
          <p>Reklamacja powinna zawierać opis problemu, dane pozwalające zidentyfikować konto Klienta oraz oczekiwany sposób rozpatrzenia sprawy. Odpowiadamy na reklamację w ciągu 14 dni od jej otrzymania.</p>
          <p>Klient ma ponadto prawo wyznaczyć Serwisowi Jaty termin pięciu dni roboczych na przywrócenie prawidłowego wykonywania świadczenia. Jeśli przyczyna reklamacji nie zostanie usunięta po upływie tego terminu, Klient ma prawo do wypowiedzenia umowy.</p>
          <p>Reklamacje mogą dotyczyć działania Serwisu Jaty, w tym jego poszczególnych funkcji. Postanowienia regulaminu nie ograniczają uprawnień Klienta wynikających z bezwzględnie obowiązujących przepisów prawa.</p>
        </li>
      </ol>
    </section>

    <section id="pkt-10" class="legal-doc__section">
      <h3>10. Prawa autorskie</h3>
      <ol class="legal-doc__clauses">
        <li><p>Wszelkie prawa do należących do Serwisu Jaty programów, procedur, treści oprogramowania, technologii, marek, nazw handlowych, wynalazków, materiałów oraz wszelkich innych praw własności intelektualnej będących częścią Serwisu Jaty przysługują wyłącznie Serwisowi Jaty. Korzystanie z wszelkich programów i zawartych w nich treści, materiałów oraz marek i nazw handlowych dopuszczalne jest wyłącznie do celów wskazanych w niniejszych Warunkach ogólnych. Powielanie należących do Serwisu Jaty programów, świadczeń, procedur, oprogramowania, technologii, marek, nazw handlowych, wynalazków oraz materiałów jest niedopuszczalne, o ile nie jest wyraźnie dozwolone przez Serwis Jaty.</p></li>
      </ol>
    </section>

    <section id="pkt-11" class="legal-doc__section">
      <h3>11. Prawo do odstąpienia od umowy, informacja na temat wykonania prawa do odstąpienia od umowy</h3>
      <h4>Prawo do odstąpienia od umowy</h4>
      <p>Klient ma prawo do odstąpienia od umowy bez podawania przyczyny w ciągu czternastu dni.</p>
      <p>Okres odstąpienia od umowy wynosi czternaście dni od dnia zawarcia umowy.</p>
      <p>W celu odstąpienia od umowy należy przesłać wyraźne oświadczenie o swojej decyzji na adres: WHIPO sp. z o.o. – Jaty, ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Polska, NIP: 5342666118, lub e-mailem na <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>. Do zachowania terminu wystarczy wysłanie oświadczenia przed jego upływem.</p>
      <h4>Skutki odstąpienia</h4>
      <p>W razie odstąpienia umowę uważa się za niezawartą, a dostęp do konta zostaje zakończony. Zamiast składać oświadczenie, możesz też po prostu usunąć konto. Zasady przetwarzania danych po zakończeniu korzystania z serwisu opisuje <a href="/polityka-prywatnosci">polityka prywatności</a>.</p>
    </section>

    <section id="pkt-12" class="legal-doc__section">
      <h3>12. Zmiana Warunków ogólnych</h3>
      <ol class="legal-doc__clauses">
        <li><p>Warunki Ogólne zawarte w Regulaminie mogą ulegać zmianom w przypadku, gdy nie mają one wpływu na zasadnicze postanowienia dotyczące stosunku umownego i że taka zmiana jest konieczna w celu adaptacji kwestii nieprzewidzianych w chwili zawierania umowy, a które w znaczący sposób naruszyłyby równowagę stosunku umownego, gdyby pozostały nieuwzględnione. „Zasadnicze postanowienia” to w szczególności takie, które odnoszą się do typu i zakresu uzgodnionych umownie usług i ich czasu trwania, włącznie z postanowieniami regulującymi ich zakończenie. Dalsze modyfikacje lub uzupełnienia Regulaminu mogą mieć miejsce, jeżeli jest to konieczne w celu rozwiązania trudności związanych z realizacją umowy, spowodowanych przez luki wynikłe po zawarciu umowy. W szczególności może to mieć miejsce, gdy zmianom ulega prawodawstwo i gdy ma to wpływ na jeden lub więcej punktów Regulaminu.</p></li>
        <li><p>Specyfikacje dotyczące usług mogą ulec zmianie, jeżeli istnieje uzasadniona potrzeba, pod warunkiem, że zmiany te nie spowodują obiektywnie mniej korzystnej sytuacji klienta (np. konieczność serwisowania lub ulepszenia funkcjonalności serwisu) niż powodowały ją specyfikacje usług obowiązujące w chwili zawierania umowy i nie różnią się one w zasadniczy sposób od wcześniejszych specyfikacji. Uzasadniona potrzeba dokonania zmian zachodzi wówczas, gdy na rynku dostępne są innowacje techniczne lub, gdy osoby trzecie, od których Jaty uzyskuje zaawansowane usługi niezbędne do prawidłowego funkcjonowania serwisu, zmieniają zakres swoich świadczeń.</p></li>
        <li><p>Klient musi zostać poinformowany o zmianach w Regulaminie oraz w specyfikacjach usług zgodnie z paragrafem 12. (1) i (2) co najmniej sześć (6) tygodni przed ich wejściem w życie. Jeżeli Klient nie akceptuje zmian, może przed ich wejściem w życie wypowiedzieć umowę, usuwając konto. Jeżeli tego nie zrobi, zmiany staną się częścią umowy w chwili ich wejścia w życie. Klient zostanie wyraźnie powiadomiony o takim skutku poprzez powiadomienie o zmianach.</p></li>
      </ol>
    </section>

    <section id="pkt-13" class="legal-doc__section">
      <h3>13. Pozostałe</h3>
      <ol class="legal-doc__clauses">
        <li><p>Jaty ma prawo zlecić osobom trzecim, które są jego usługodawcami i wykonawcami, świadczenie części lub całości zakresu świadczonych usług, pod warunkiem że nie powoduje to jakichkolwiek niekorzyści dla klienta.</p></li>
        <li><p>Jeśli poszczególne postanowienia niniejszych Warunków ogólnych bądź umowy są lub staną się nieważne ważność pozostałych postanowień pozostaje wiążąca dla stron.</p></li>
        <li><p>Obowiązującym prawem w stosunkach pomiędzy Klientem i Serwisem Jaty jest prawo polskie, z zastrzeżeniem obowiązkowych postanowień Rozporządzenia UE nr 593/2008.</p></li>
        <li><p>Niniejsze Warunki ogólne nie wyłączają ani nie ograniczają praw Klienta wynikających z bezwzględnie obowiązujących przepisów prawa.</p></li>
        <li><p>Właścicielem i operatorem Serwisu Jaty jest WHIPO sp. z o.o. z siedzibą przy ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Polska, NIP: 5342666118.</p></li>
      </ol>
    </section>
  </article>`,

  privacy_policy_content: `<article class="legal-doc">
    <header class="legal-doc__header">
      <h2 class="legal-doc__title">Polityka prywatności serwisu www.jaty.pl</h2>
    </header>

    <nav class="legal-doc__toc" aria-label="Spis treści">
      <p class="legal-doc__toc-title">Spis treści</p>
      <ol>
        <li><a href="#administrator">1. Administrator danych</a></li>
        <li><a href="#zakres-danych">2. Jakie dane przetwarzamy</a></li>
        <li><a href="#cele">3. Cele i podstawy prawne</a></li>
        <li><a href="#okres">4. Jak długo przechowujemy dane</a></li>
        <li><a href="#odbiorcy">5. Odbiorcy danych</a></li>
        <li><a href="#poza-eog">6. Przekazywanie danych poza EOG</a></li>
        <li><a href="#decyzje-automatyczne">7. Zautomatyzowane decyzje</a></li>
        <li><a href="#prawa">8. Twoje prawa</a></li>
        <li><a href="#usuniecie-konta">9. Usunięcie konta</a></li>
        <li><a href="#pozostale">10. Bezpieczeństwo, linki i zmiany polityki</a></li>
        <li><a href="#moderacja-dane">11. Dane wykorzystywane w moderacji AI</a></li>
        <li><a href="#analityka">12. Statystyki odwiedzin i narzędzia zewnętrzne</a></li>
        <li><a href="#zrodlo-rejestracji">13. Informacja o źródle rejestracji</a></li>
      </ol>
    </nav>

    <section id="administrator" class="legal-doc__section">
      <h3>1. Administrator danych</h3>
      <p>Administratorem danych osobowych przetwarzanych w Serwisie Jaty jest WHIPO sp. z o.o. z siedzibą przy ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Polska, NIP: 5342666118. W sprawach dotyczących danych osobowych można skontaktować się z administratorem pod tym adresem lub e-mailem: <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>.</p>
      <p>Niniejsza polityka opisuje, jakie dane przetwarzamy w związku z korzystaniem z serwisu randkowego Jaty, w jakich celach, jak długo oraz jakie prawa Ci przysługują.</p>
    </section>

    <section id="zakres-danych" class="legal-doc__section">
      <h3>2. Jakie dane przetwarzamy</h3>
      <ul>
        <li><strong>Dane konta</strong> – adres e-mail, hasło (w postaci zaszyfrowanej), imię, płeć, informacja, kogo szukasz, data urodzenia, miasto i preferencje wyszukiwania. Przy logowaniu przez Facebooka otrzymujemy od Facebooka podstawowe dane potrzebne do założenia konta, np. imię i adres e-mail.</li>
        <li><strong>Profil</strong> – opis, zdjęcia oraz dodatkowe informacje, które zdecydujesz się podać (np. wzrost, wykształcenie, wyznanie).</li>
        <li><strong>Aktywność w serwisie</strong> – serduszka, pary, wiadomości, wyświetlenia profili, blokady i czas ostatniej aktywności.</li>
        <li><strong>Moderacja i bezpieczeństwo</strong> – zgłoszenia, ostrzeżenia, decyzje moderacyjne i ich uzasadnienie, kraj połączenia ustalony na podstawie adresu IP oraz zdjęcie weryfikacyjne, jeśli o nie poprosimy.</li>
        <li><strong>Dane techniczne</strong> – cookies i podobne technologie opisane w <a href="/cookies">polityce cookies</a>, ustawienia powiadomień oraz subskrypcja powiadomień push, jeśli ją włączysz.</li>
        <li><strong>Korespondencja</strong> – treść wiadomości wysłanych do nas e-mailem lub przez formularz kontaktowy, w tym reklamacji i odwołań.</li>
      </ul>
      <p>Podanie danych konta jest dobrowolne, ale niezbędne do korzystania z serwisu. Pozostałe informacje w profilu podajesz według własnego uznania.</p>
      <p>Niektóre informacje, np. wyznanie albo to, kogo szukasz (co może wskazywać na orientację seksualną), należą do szczególnych kategorii danych. Podajesz je dobrowolnie i są widoczne w Twoim profilu; przetwarzamy je na podstawie Twojej wyraźnej zgody, którą możesz wycofać, usuwając te informacje z profilu lub usuwając konto.</p>
    </section>

    <section id="cele" class="legal-doc__section">
      <h3>3. Cele i podstawy prawne</h3>
      <table class="legal-doc__table">
        <thead>
          <tr><th scope="col">Cel</th><th scope="col">Podstawa prawna (RODO)</th></tr>
        </thead>
        <tbody>
          <tr><td>Założenie i prowadzenie konta, profil, dopasowania, wiadomości i powiadomienia</td><td>wykonanie umowy – art. 6 ust. 1 lit. b</td></tr>
          <tr><td>Dane szczególnych kategorii podane w profilu</td><td>wyraźna zgoda – art. 9 ust. 2 lit. a</td></tr>
          <tr><td>Moderacja treści, ochrona przed spamem, oszustwami i fałszywymi kontami, weryfikacja kont</td><td>prawnie uzasadniony interes (bezpieczeństwo użytkowników i serwisu) – art. 6 ust. 1 lit. f</td></tr>
          <tr><td>Informowanie osób, z którymi konto miało parę lub rozmowę, o jego usunięciu lub zablokowaniu</td><td>prawnie uzasadniony interes (wyjaśnienie, dlaczego para i rozmowa zniknęły, oraz ochrona przed oszustwami) – art. 6 ust. 1 lit. f</td></tr>
          <tr><td>Obsługa kontaktu, reklamacji i odwołań</td><td>wykonanie umowy i obowiązki prawne – art. 6 ust. 1 lit. b i c</td></tr>
          <tr><td>Google Analytics i zapis źródła rejestracji</td><td>zgoda – art. 6 ust. 1 lit. a</td></tr>
          <tr><td>Zbiorcze statystyki odwiedzin (Simple Analytics)</td><td>prawnie uzasadniony interes – art. 6 ust. 1 lit. f</td></tr>
          <tr><td>Ustalenie, dochodzenie lub obrona roszczeń</td><td>prawnie uzasadniony interes – art. 6 ust. 1 lit. f</td></tr>
        </tbody>
      </table>
      <p>Nie sprzedajemy danych osobowych użytkowników i nie wykorzystujemy ich do reklam.</p>
    </section>

    <section id="okres" class="legal-doc__section">
      <h3>4. Jak długo przechowujemy dane</h3>
      <ul>
        <li><strong>Dane konta, profil, aktywność i wiadomości</strong> – do czasu usunięcia konta.</li>
        <li><strong>Historia moderacji</strong> (zgłoszenia, ostrzeżenia, decyzje i związane z nimi logi, także po zablokowaniu konta) – do czasu usunięcia konta. Osoba z zablokowanym kontem może zażądać jego usunięcia, pisząc na <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>.</li>
        <li><strong>Informacja o usuniętym lub zablokowanym koncie</strong> – imię lub pseudonim z profilu w powiadomieniu dla osób, z którymi konto miało parę lub rozmowę: po usunięciu konta przez 30 dni, a przy blokadzie (wraz z miniaturą zdjęcia z profilu) do czasu jej cofnięcia lub usunięcia konta.</li>
        <li><strong>Zdjęcie weryfikacyjne</strong> – do czasu podjęcia decyzji przez moderatora, a następnie jest usuwane.</li>
        <li><strong>Korespondencja, reklamacje i odwołania</strong> – przez czas potrzebny do ich obsługi, a następnie do upływu terminu przedawnienia ewentualnych roszczeń.</li>
        <li><strong>Dane analityczne</strong> – zgodnie z opisem w <a href="/cookies">polityce cookies</a>; dane zapisane przy koncie – do czasu usunięcia konta.</li>
        <li><strong>Kopie zapasowe</strong> – do 12 miesięcy. Służą wyłącznie do odtworzenia serwisu po awarii; dane w nich zawarte nie są w tym czasie w żaden inny sposób wykorzystywane ani przetwarzane.</li>
      </ul>
      <p>Serwis może również usuwać nieaktywne konta i archiwizować lub usuwać starsze treści, zgodnie z regulaminem.</p>
    </section>

    <section id="odbiorcy" class="legal-doc__section">
      <h3>5. Odbiorcy danych</h3>
      <p>Dane mogą być przekazywane podmiotom, które pomagają nam prowadzić serwis i przetwarzają je w naszym imieniu lub jako odrębni administratorzy:</p>
      <ul>
        <li>dostawcom hostingu, infrastruktury serwerowej oraz usług ochrony i przyspieszania ruchu sieciowego;</li>
        <li>dostawcy usług poczty e-mail oraz usług powiadomień push przeglądarki;</li>
        <li>dostawcy narzędzi sztucznej inteligencji wykorzystywanych do moderacji (punkt 11);</li>
        <li>dostawcom narzędzi analitycznych – Google Analytics tylko po zgodzie oraz Simple Analytics (punkt 12);</li>
        <li>Meta Platforms (Facebook) – jeśli logujesz się przez Facebooka;</li>
        <li>organom publicznym, gdy wymagają tego przepisy prawa.</li>
      </ul>
      <p>Dane profilu są widoczne dla innych użytkowników serwisu. Wiadomości widzi tylko ich odbiorca; nie są publikowane ani udostępniane pozostałym użytkownikom.</p>
    </section>

    <section id="poza-eog" class="legal-doc__section">
      <h3>6. Przekazywanie danych poza EOG</h3>
      <p>Niektórzy dostawcy, np. narzędzi AI, analityki lub infrastruktury, mogą przetwarzać dane poza Europejskim Obszarem Gospodarczym, w tym w USA. W takim przypadku przekazanie odbywa się z zastosowaniem mechanizmów przewidzianych w RODO, takich jak decyzja Komisji Europejskiej stwierdzająca odpowiedni stopień ochrony lub standardowe klauzule umowne.</p>
    </section>

    <section id="decyzje-automatyczne" class="legal-doc__section">
      <h3>7. Zautomatyzowane decyzje</h3>
      <p>W ramach moderacji narzędzia AI mogą samodzielnie podjąć decyzję o usunięciu treści, ostrzeżeniu lub zablokowaniu konta, zgodnie z zasadami opisanymi w <a href="/regulamin#moderacja">regulaminie</a>. Masz prawo do interwencji człowieka, przedstawienia własnego stanowiska i zakwestionowania takiej decyzji – napisz na <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>. Nie stosujemy profilowania w celach marketingowych.</p>
    </section>

    <section id="prawa" class="legal-doc__section">
      <h3>8. Twoje prawa</h3>
      <p>Masz prawo do:</p>
      <ul>
        <li>dostępu do swoich danych i otrzymania ich kopii;</li>
        <li>sprostowania danych – większość z nich możesz zmienić samodzielnie w ustawieniach konta;</li>
        <li>usunięcia danych;</li>
        <li>ograniczenia przetwarzania;</li>
        <li>przenoszenia danych;</li>
        <li>sprzeciwu wobec przetwarzania opartego na prawnie uzasadnionym interesie;</li>
        <li>wycofania zgody w dowolnym momencie – bez wpływu na zgodność z prawem przetwarzania przed jej wycofaniem.</li>
      </ul>
      <p>Aby skorzystać z tych praw, napisz na <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a> lub skorzystaj z <a href="/kontakt">formularza kontaktowego</a>. Masz też prawo wnieść skargę do Prezesa Urzędu Ochrony Danych Osobowych.</p>
    </section>

    <section id="usuniecie-konta" class="legal-doc__section">
      <h3>9. Usunięcie konta</h3>
      <p>Konto możesz w każdej chwili usunąć w ustawieniach konta (opcja „Usuń konto”) albo poprosić o jego usunięcie, pisząc na <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>. Usunięcie konta usuwa dane konta, profil, wiadomości i historię moderacji, z wyjątkiem imienia lub pseudonimu w powiadomieniu o usunięciu konta, które przez 30 dni widzą osoby, z którymi masz parę lub rozmowę (punkt 4); w kopiach zapasowych dane pozostają najdłużej przez okres wskazany w punkcie 4.</p>
      <p>Przy usunięciu konta do celów statystycznych zachowujemy wyłącznie płeć, wiek, miasto i podany powód rezygnacji, bez danych pozwalających zidentyfikować konkretną osobę.</p>
    </section>

    <section id="pozostale" class="legal-doc__section">
      <h3>10. Bezpieczeństwo, linki i zmiany polityki</h3>
      <p>Stosujemy środki techniczne i organizacyjne chroniące dane przed dostępem osób nieupoważnionych, utratą lub zniszczeniem.</p>
      <p>W serwisie mogą pojawiać się linki do innych stron internetowych. Działają one niezależnie od Jaty i mają własne zasady prywatności, z którymi zalecamy się zapoznać.</p>
      <p>Polityka może się zmieniać, np. w związku z rozwojem serwisu lub zmianą przepisów. O istotnych zmianach poinformujemy w serwisie lub e-mailem.</p>
    </section>

    <section id="moderacja-dane" class="legal-doc__section">
    <h3>11. Dane wykorzystywane w moderacji AI</h3>
    <p>Aby wykrywać naruszenia regulaminu, spam i oszustwa, sprawdzamy publiczne opisy, zdjęcia, dane konta, historię ostrzeżeń oraz treść wysłanych prywatnych wiadomości. Prywatne wiadomości podlegają więc moderacji, choć nie są publicznie widoczne.</p>
    <p>Korzystamy przy tym z narzędzi AI zewnętrznego dostawcy, do którego mogą być przekazywane sprawdzane treści i dane konta. Dostawca może przetwarzać dane poza Europejskim Obszarem Gospodarczym (punkt 6).</p>
    <p>Zasady moderacji opisuje <a href="/regulamin#moderacja">regulamin</a>. Na potrzeby odwołań zapisujemy ocenioną treść, przyczynę decyzji i jej wynik. Blokada konta nie oznacza usunięcia wszystkich danych. Od decyzji możesz się odwołać, pisząc na <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a> – odwołanie rozpatruje człowiek.</p>
    <p>W celu ochrony przed fałszywymi kontami porównujemy kraj, z którego nawiązywane jest połączenie (na podstawie adresu IP), z miastem podanym w profilu. W razie niezgodności możemy poprosić o zdjęcie weryfikacyjne. Zdjęcie ogląda moderator, a po podjęciu decyzji jest ono usuwane.</p>
    </section>

    <section id="analityka" class="legal-doc__section">
    <h3>12. Statystyki odwiedzin i narzędzia zewnętrzne</h3>
    <p>Do statystyk odwiedzin używamy Simple Analytics. Oddzielamy ten pomiar od danych rejestracyjnych zapisanych przy koncie. Google Analytics włączamy wyłącznie po zgodzie na analitykę; przetwarzanie tych danych opieramy na zgodzie. Cele pomiaru oraz informacje o cookies i prywatności dostawców opisuje <a href="/cookies">polityka cookies</a>. Samo korzystanie z serwisu ani akceptacja niniejszej polityki nie stanowią zgody na opcjonalne śledzenie.</p>
    </section>

    <section id="zrodlo-rejestracji" class="legal-doc__section">
    <h3>13. Informacja o źródle rejestracji</h3>
    <p>Po zgodzie na analitykę przy tworzeniu konta możemy zapisać pierwszą odwiedzoną ogólną ścieżkę strony oraz źródło wejścia z parametru utm_source, np. nazwę kampanii. Informacje są odczytywane z cookies first_page_visited i first_utm_source. Dotyczy to również rejestracji przez Facebooka.</p>
    <p>Celem jest ustalenie, skąd przychodzą osoby zakładające konto. Dane te są przypisane do konta, a nie anonimowe. Ich brak nie blokuje rejestracji ani funkcji konta. Pomiar źródła opieramy na zgodzie (art. 6 ust. 1 lit. a RODO). Jest opcjonalny i nie jest warunkiem zawarcia umowy o korzystanie z serwisu. Akceptacja regulaminu nie zastępuje uprzedniej zgody na opcjonalny zapis i odczyt cookies.</p>
    <p>Zapisane informacje pozostają częścią danych konta, także po zamknięciu przeglądarki lub usunięciu cookies. W sprawie dostępu do tych danych, ich sprostowania, usunięcia lub ograniczenia przetwarzania napisz na <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>. Prawa te przysługują na warunkach określonych w RODO. Możesz też wnieść skargę do Prezesa Urzędu Ochrony Danych Osobowych.</p>
    </section>
  </article>`,

  cookies_content: `
    <article class="legal-doc">
    <header class="legal-doc__header">
      <h2 class="legal-doc__title">Polityka cookies serwisu JaTy</h2>
    </header>
    <div class="legal-doc__intro">
      <p>Cookies to niewielkie informacje zapisywane w przeglądarce. Pomagają utrzymać zalogowanie i zapamiętać wybory, ale mogą też służyć pomiarowi ruchu oraz reklamie. Operatorem serwisu jest WHIPO sp. z o.o., ul. Waltorni 15/1, 05-090 Dawidy Bankowe, Polska, NIP: 5342666118. Kontakt: <a href="mailto:jaty@jaty.pl">jaty@jaty.pl</a>.</p>
    </div>

    <nav class="legal-doc__toc" aria-label="Spis treści">
      <p class="legal-doc__toc-title">Spis treści</p>
      <ol>
        <li><a href="#cookies-niezbedne">1. Obsługa konta i Twoich wyborów</a></li>
        <li><a href="#cookies-zrodlo">2. Źródło rejestracji</a></li>
        <li><a href="#cookies-simple-analytics">3. Simple Analytics</a></li>
        <li><a href="#cookies-google-analytics">4. Google Analytics</a></li>
        <li><a href="#cookies-zgoda">5. Zgoda i zarządzanie danymi</a></li>
      </ol>
    </nav>

    <section id="cookies-niezbedne" class="legal-doc__section">
    <h3>1. Obsługa konta i Twoich wyborów</h3>
    <ul>
      <li><strong>Sesja i bezpieczeństwo</strong> – cookies sesji, mechanizmu logowania oraz ochrony formularzy, w tym <code>XSRF-TOKEN</code>. Umożliwiają rozpoznanie zalogowanego użytkownika i ochronę żądań kierowanych do serwisu. Ważność cookies logowania wynosi do 365 dni; sesja może zakończyć się wcześniej, np. po wylogowaniu.</li>
      <li><strong>Wybrany język</strong> – <code>preffered-lang</code> zapamiętuje język strony przez 365 dni od zapisu.</li>
      <li><strong>Zamknięcie propozycji powiadomień</strong> – <code>notification-box-shown</code> przez 7 dni zapamiętuje zamknięcie komunikatu. Zgody na powiadomienia push udzielasz oddzielnie w przeglądarce.</li>
      <li><strong>Parametr linku rejestracyjnego</strong> – <code>free-month</code> może zostać zapisany na 1 dzień po otwarciu linku z parametrem free_month. Pochodzi ze starszego mechanizmu promocyjnego; nie oznacza uruchomienia płatności ani subskrypcji.</li>
    </ul>
    <p>Wybór zgody lub odmowy zapisujemy pod nazwą <code>jaty-consent</code> w cookie i pamięci lokalnej przeglądarki (localStorage) na 5 lat (1825 dni). Dzięki temu nie pytamy podczas każdej wizyty. Po upływie tego okresu, usunięciu danych strony lub istotnej zmianie zakresu zgody prosimy o nowy wybór. Przeglądarka może usunąć zapis wcześniej.</p>
    </section>

    <section id="cookies-zrodlo" class="legal-doc__section">
    <h3>2. Źródło rejestracji – po zgodzie na analitykę</h3>
    <p>Po zgodzie na analitykę cookie <code>first_page_visited</code> zapamiętuje pierwszą odwiedzoną ścieżkę strony, a <code>first_utm_source</code> pierwszą napotkaną wartość utm_source z linku, np. nazwę kampanii. Są to cookies sesyjne; przeglądarka może je zachować przy przywracaniu sesji.</p>
    <p>Przy rejestracji, także przez Facebooka, dostępne wartości są przekazywane do JaTy i zapisywane przy koncie jako pierwsza odwiedzona strona oraz źródło pozyskania użytkownika. Ten pomiar jest powiązany z kontem, więc nie jest anonimową statystyką. Nie jest potrzebny do założenia konta, logowania ani rozmów. Usunięcie cookies z przeglądarki nie usuwa informacji już zapisanych przy koncie.</p>
    </section>

    <section id="cookies-simple-analytics" class="legal-doc__section">
    <h3>3. Simple Analytics</h3>
    <p>Korzystamy z Simple Analytics do zbiorczych statystyk odwiedzin. Według dokumentacji dostawcy narzędzie nie używa cookies ani trwałych identyfikatorów odwiedzających. Nasza integracja respektuje Do Not Track (DNT), zastępuje adresy profili i tokeny ogólnymi ścieżkami oraz wyłącza metryki UTM i źródła odsyłającego. Jest to odrębne od zapisu źródła przy koncie opisanego powyżej. <a href="https://docs.simpleanalytics.com/privacy" rel="noreferrer">Informacje o prywatności Simple Analytics</a>.</p>
    </section>

    <section id="cookies-google-analytics" class="legal-doc__section">
    <h3>4. Google Analytics – po zgodzie na analitykę</h3>
    <p>Google Analytics uruchamiamy dopiero po zgodzie. Służy do pomiaru odwiedzin i korzystania ze strony. Cookies <code>_ga</code> i <code>_ga_*</code> pozwalają odróżnić przeglądarki oraz powiązać odsłony; ustawiamy ich ważność na 180 dni. Google jest odbiorcą danych pomiarowych. Nie przekazujemy do pomiaru identyfikatora konta, treści wiadomości ani nazw profili; raportujemy ogólne ścieżki stron.</p>
    <p>Zgoda na analitykę nie obejmuje personalizacji reklam. Nie korzystamy z Google Ads, AdSense, Hotjara ani Facebook Pixela. Logowanie przez Facebooka pozostaje odrębną funkcją uruchamianą na Twoje żądanie.</p>
    <p>Informacje dostawcy o cookies i przetwarzaniu danych: <a href="https://policies.google.com/technologies/cookies?hl=pl" rel="noreferrer">Google – cookies</a> oraz <a href="https://policies.google.com/privacy?hl=pl" rel="noreferrer">polityka prywatności Google</a>.</p>
    </section>

    <section id="cookies-zgoda" class="legal-doc__section">
    <h3>5. Zgoda i zarządzanie danymi</h3>
    <p>Analityka jest domyślnie wyłączona. Możesz wybrać „Akceptuję wszystkie”, „Tylko niezbędne” albo własne ustawienia. Zgoda obejmuje Google Analytics oraz pomiar źródła rejestracji. Akceptacja regulaminu lub polityki prywatności nie zastępuje takiej zgody. Wyjątek dotyczy operacji niezbędnych do transmisji lub dostarczenia usługi żądanej przez użytkownika.</p>
    <p>W każdej chwili możesz użyć przycisku „Ustawienia cookies” na stronie polityki cookies lub opcji w menu konta i wycofać zgodę równie łatwo jak jej udzielić. Zatrzymujemy wtedy dalszy pomiar Google Analytics i zapis źródła oraz usuwamy dostępne dla serwisu cookies analityczne. Nie usuwa to automatycznie wcześniej zebranych danych ani informacji zapisanych przy koncie. Wycofanie zgody nie wpływa na zgodność z prawem wcześniejszego przetwarzania.</p>
    <p>W ustawieniach prywatności przeglądarki możesz przeglądać, usuwać i blokować cookies oraz sprawdzać ich daty wygaśnięcia. Zablokowanie cookies sesji i bezpieczeństwa może uniemożliwić logowanie; usunięcie preferencji języka może wymagać ponownego wyboru języka. Ustawienia przeglądarki nie zastępują obowiązku uzyskania przez serwis zgody na opcjonalne technologie.</p>
    <p>Informacje o danych zapisanych przy koncie i sposobie kontaktu z administratorem znajdziesz w <a href="/polityka-prywatnosci#zrodlo-rejestracji">polityce prywatności</a>.</p>
    </section>
    </article>`,

  //shame
  'Normalna': 'Normalna',
  'Muskularna': 'Muskularna',
  'Lekko puszysta': 'Lekko puszysta',
  'Puszysta': 'Puszysta',
  '120 i mniej': '120 i mniej',
  '211 i więcej': '211 i więcej',
  'Posiadam dzieci': 'Posiadam dzieci',
  'Chce mieć': 'Chce mieć',
  'Jeszcze nie wiem': 'Jeszcze nie wiem',
  'Brązowe (piwne)': 'Brązowe (piwne)',
  'Niebieskie': 'Niebieskie',
  'Szare': 'Szare',
  'Mieszane': 'Mieszane',
  'Panna / Kawaler': 'Panna',
  'Mam żonę': 'Mam żonę',
  'Mam męża': 'Mam męża',
  'Rozwódka / Rozwodnik': 'Rozwiedziona',
  'Wdowa / Wdowiec': 'Wdowa',
  'Separacja': 'Separacja',
  'Uczeń / Student': 'Uczeń / Student',
  'Emeryt': 'Emeryt',
  'Rencista': 'Rencista',
  'Niepracujący': 'Niepracujący',
  'Przedsiębiorca': 'Przedsiębiorca',
  'Usługi': 'Usługi',
  'Handel': 'Handel',
  'Pracownik biurowy': 'Pracownik biurowy',
  'Pracownik fizyczny': 'Pracownik fizyczny',
  'Służba mundurowa': 'Służba mundurowa',
  'Służba zdrowia': 'Służba zdrowia',
  'Edukacja': 'Edukacja',
  'Kierownik / Manager': 'Kierownik / Manager',
  'Dyrektor / Prezes': 'Dyrektor / Prezes',
  'Działalność artystyczna': 'Działalność artystyczna',
  'Działalność publiczna': 'Działalność publiczna',
  'Marketingowiec / PR\'owiec': 'Marketingowiec / PR\'owiec',
  'Działalność naukowa': 'Działalność naukowa',
  'Inne': 'Inne',
  'Bardzo chcę małżeństwa': 'Bardzo chcę małżeństwa',
  'Dopuszczam myśl o małżeństwie': 'Dopuszczam myśl o małżeństwie',
  'Nie chcę małżeństwa': 'Nie chcę małżeństwa',
  'Podstawowe': 'Podstawowe',
  'Średnie': 'Średnie',
  'Pomaturalne': 'Pomaturalne',
  'Licencjat': 'Licencjat',
  'Podyplomowe': 'Podyplomowe',
  'Wyższe niepełne': 'Wyższe niepełne',
  'Wyższe': 'Wyższe',
  'Katolicyzm': 'Katolicyzm',
  'Prawosławie': 'Prawosławie',
  'Protestantyzm': 'Protestantyzm',
  'Świadek Jechowy': 'Świadek Jechowy',
  'Buddyzm': 'Buddyzm',
  'Hinduizm': 'Hinduizm',
  'Islam': 'Islam',
  'Judaizm': 'Judaizm',
  'Ateizm': 'Ateizm',
  'Nie chcę mówić': 'Nie chcę mówić',
  'Inna': 'Inna',

  images: {
    hero: '/portal-randkowy/assets/img/hero.webp',
    mobile_jaty: '/portal-randkowy/assets/img/mobile-jaty.webp',
    chat: '/portal-randkowy/assets/img/chat.webp',
    play_badge: '/pl/google/play_badge.svg'
  }
}
